/* eslint-disable max-len */
// Page builder
import { BlockTypeModel } from '../../PageBuilder/models/block-type.model';

// This module
import { ChartDisplayElementModel } from './chart-display-element.model';
import { ChartBlockComponent } from '../components/ChartBlock/chart-block.component';
import { DateRangeFieldModel } from './date-range-field.model';
import { DateRangeFieldComponent } from '../components/DateRangeField/date-range-field.component';
import { TextFieldModel } from '../../PageBuilder/models/text-field.model';
import { TextFieldComponent } from '../../PageBuilder/components/FormFields/TextField/text-field.component';
import { ReportBlockTypeEnum } from '../enums/report-block-type.enum';
import { SeriesPickerFieldModel } from './series-picker-field.model';
import { mentionSeriesTypes, SeriesTypeEnum, socialSeriesTypes } from '../enums/series-type.enum';
import { SeriesPickerFieldComponent } from '../components/SeriesPickerField/series-picker-field.component';
import { DropdownOptionModel } from '../../Forms/models/dropdown-option.model';
import { CoverageSummaryChartBlockComponent } from '../components/CoverageSummaryChartBlock/coverage-summary-chart-block.component';
import { CheckboxesFieldModel } from '../../PageBuilder/models/checkboxes-field.model';
import { CheckboxesFieldComponent } from '../../PageBuilder/components/FormFields/CheckboxesField/checkboxes-field.component';
import { CheckboxOptionModel } from '../../Forms/models/checkbox-option.model';
import { CoverageSummaryChartDisplayElementModel } from './coverage-summary-chart-display-element.model';
import { RegionPickerFieldComponent } from '../components/RegionPickerField/region-picker-field.component';
import { RegionPickerFieldModel } from './region-picker-field.model';
import { SeriesFilterTypesEnum, socialSeriesFilterTypes } from '../enums/series-filter-types.enum';
import { LabelDisplayOptionsEnum } from '../../Misc/enums/label-display-options.enum';
import { SearchCriteriaQuerySentimentsEnum } from '../../../api/mentions/enum/search-criteria-query-sentiments.enum';
import { SeriesPickerCompareFieldModel } from './series-picker-compare-field.model';
import { SeriesPickerCompareFieldComponent } from '../components/SeriesPickerCompareField/series-picker-compare-field.component';
import { chartColors } from '../../Charts/enums/chart-colors.enum';
import { ColorPickerFieldModel } from '../../PageBuilder/models/color-picker-field.model';
import { ColorPickerFieldComponent } from '../../PageBuilder/components/FormFields/ColorPickerField/color-picker-field.component';
import { StaticTextHeadingFieldComponent } from '../../PageBuilder/components/FormFields/StaticTextHeadingField/static-text-heading-field.component';
import { StaticTextHeadingFieldModel } from '../../PageBuilder/models/static-text-heading-field.model';
import { ChartMetricsEnum, chartMetricsToCoverageMetricIconsMap } from '../enums/chart-metrics.enum';
import { ChartAnalysisMetricDropdownFieldModel } from './chart-analysis-metric-dropdown-field.model';
import { ExternalDataSourcePickerFieldModel } from '../components/ExternalDataSourcePickerField/external-data-source-picker-field.model';
import { ExternalDataSourcePickerFieldComponent } from '../components/ExternalDataSourcePickerField/external-data-source-picker-field.component';
import { ExternalDataSourceDateRangeFieldComponent } from '../components/ExternalDataSourceDateRangeField/external-data-source-date-range-field.component';
import { ExternalDataSourceDateRangeFieldModel } from './external-data-source-date-range-field.model';
import { GoogleAnalyticsReportTypesEnum } from '../../../api/externalData/enums/google-analytics-report-types.enum';
import { PREventsFieldComponent, PREventsFieldModel } from '../components/PREventsField/pr-events-field.component';
import { ProminenceGroupPickerModel } from '../components/ProminenceGroupPicker/prominence-group-picker.model';
import { ProminenceGroupPickerComponent } from '../components/ProminenceGroupPicker/prominence-group-picker.component';
import { RadioButtonOptionModel } from '../../Forms/models/radio-button-option.model';
import { RadioButtonsFieldComponent } from '../../PageBuilder/components/FormFields/RadioButtonsField/radio-buttons-field.component';
import { RadioButtonsFieldModel } from '../../PageBuilder/models/radio-buttons-field.model';
import { ExternalChartMetricsEnum } from '../enums/external-chart-metrics.enum';
import { ChartDataDisplaySettingsCheckboxFieldComponent } from '../components/ChartDataDisplaySettingsCheckboxFieldComponent/chart-data-display-settings-checkbox-field.component';
// export block types
import { recentTopicActivityBlockType } from '../../Dashboard/models/BlockTypes/recent-topic.const';
import { recentTargetingActivityBlockType } from '../../Dashboard/models/BlockTypes/recent-targeting-activity.const';
import { recentDistributionActivityBlockType } from '../../Dashboard/models/BlockTypes/recent-distribution-activity.const';
import { recentReportsDistributionsBlockType } from '../../Dashboard/models/BlockTypes/recent-reports-distributions.const';
import { ChartColorPickerFieldComponent } from '../../PageBuilder/components/FormFields/ChartColorPickerField/chart-color-picker-field.component';
import { ChartColorPickerFieldModel } from '../../PageBuilder/models/chart-color-picker-field.model';
import { UserAppPreferenceChartColors } from '../../../Core/Users/models/user-app-preferences-chart-colors.model';
import { ChartColorCheckboxesFieldModel } from '../../PageBuilder/models/chart-color-checkboxes-field.model';
import { ChartColorCheckboxesFieldComponent } from '../../PageBuilder/components/FormFields/ChartColorCheckboxesField/chart-color-checkboxes-field.component';
import { ChartColorCheckboxOptionModel } from '../../Forms/models/chart-color-checkbox-option.model';
import { ChartColorRadioOptionModel } from '../../Forms/models/chart-color-radio-option.model';
import { MetricPickerComponent } from '../components/MetricPickerComponent/metric-picker.component';
import { SocialSeriesMetricsEnum } from '../../../Social/Intelligence/enums/social-series-metrics.enum';
import { MultipleMetricsPickerComponent } from '../components/MultipleMetricsPickerComponent/multiple-metrics-picker.component';
import { ChartSpecificTypesEnum } from '../enums/chart-specific-types.enum';
import { DropdownFieldModel } from '../../PageBuilder/models/dropdown-field.model';
import { DropdownFieldComponent } from '../../PageBuilder/components/FormFields/DropdownField/dropdown-field.component';
import { TermTypesEnum } from '../enums/term-types.enum';
import { TopTermChartBlockComponent } from '../components/TopTermChartBlock/top-term-chart-block.component';
import { BlockComponent } from '../../PageBuilder/components/Block/block.component';
import { SimpleChange, Type } from '@angular/core';
import { TermTypesRadioButtonsFieldComponent } from '../components/TermTypesRadioButtonsFieldComponent/term-types-radio-buttons-field.component';
import { ChartNetworkCheckboxFieldComponent } from '../components/ChartNetworkSelectionCheckboxFieldComponent/chart-network-checkbox-field.component';
import { MediaTypeColorPickerWrapperFieldComponent } from '../../PageBuilder/components/FormFields/MediaTypeColorPickerWrapperField/media-type-color-picker-wrapper-field.component';
import { MediaTypeCollectionTypesEnum, MediaTypeColorPickerWrapperFieldModel } from '../../PageBuilder/models/media-type-color-picker-wrapper-field.model';
import { DashboardTopTermChartBlockComponent } from '../../Dashboard/components/DashboardTopTermChartBlock/dashboard-top-term-chart-block.component';
import { DashboardChartBlockComponent } from '../../Dashboard/components/DashboardChartBlock/dashboard-chart-block.component';
import { ChartDisplaySettingsFieldModel } from './chart-display-settings-field.model';
import { ChartDisplaySettingsFieldComponent } from '../components/ChartDisplaySettingsField/chart-display-settings-field.component';
import { MapChartColorSchemeEnum, MapChartChoroplethInterpolationTypeEnum } from '../../Charts/models/map-chart.model';
import { ConditionalTextHeadingFieldModel } from '../../PageBuilder/models/conditional-text-heading-field.model';
import { ConditionalTextHeadingFieldComponent } from '../../PageBuilder/components/FormFields/ConditionalTextHeadingField/conditional-text-heading-field.component';
import { recentSurgeActivityBlockType } from '../../../Common/Dashboard/models/BlockTypes/recent-surge-activity.const';
import { ChartTimeIntervalsEnum } from '../enums/chart-time-intervals.enum';
import { TimeIntervalDropdownFieldComponent } from '../components/TimeIntervalDropdownField/time-interval-dropdown-field.component';
import { TopMentionsSortFieldComponent } from '../components/TopMentions/TopMentionsSortField/top-mentions-sort-field.component';
import { TopMentionsMetadataFieldModel } from './top-mentions-metadata-field.model';
import { TopMentionsMetadataFieldComponent } from '../components/TopMentions/TopMentionsMetadataField/top-mentions-metadata-field.component';
import { TopMentionsChartBlockComponent } from '../components/TopMentions/TopMentionsChartBlock/top-mentions-chart-block.component';
import { TopCuratedMentionsFieldComponent } from '../components/TopMentions/TopCuratedMentionsField/top-curated-mentions-field.component';
import { TopCuratedMentionsFieldModel } from './top-curated-mentions-field.model';
import { SearchCriteriaSortFieldEnum } from '../../../api/mentions/enum/search-criteria-sort-field.enum';
import { OptionalMediaTypeColorPickerFieldComponent } from '../../PageBuilder/components/FormFields/OptionalMediaTypeColorPickerField/optional-media-type-color-picker-field.component';
import { TopPostChartBlockComponent } from '../components/TopPostChartBlock/top-post-chart-block.component';
import { DisplayElementModel } from '../../../Common/PageBuilder/models/display-element.model';
import { PreviousPeriodBarColorsEnum } from '../enums/previous-period-bar-colors.enum';
import { StackedChartTypesEnum } from '../enums/stacked-chart-types.enum';
import { EntityType } from '../../../api/targeting/enum/entity.type.enum';
import { NumberFieldModel } from '../../../Common/PageBuilder/models/number-field.model';
import { NumberFieldComponent } from '../../../Common/PageBuilder/components/FormFields/NumberField/number-field.component';
import { CoverageMetricChartDisplaySettingsField } from './coverage-metric-chart-display-settings-field.model';
import { CoverageMetricChartDisplaySettingsFieldComponent } from '../components/CoverageMetricChartDisplaySettingsField/coverage-metric-chart-display-settings-field.component';
import { CoverageMetricChartBlockComponent } from '../components/CoverageMetricChartBlock/coverage-metric-chart-block.component';
import { CoverageMetricChartDisplayElement } from './coverage-metric-chart-display-element.model';
import { ChartIconEnum, chartIconToCoverageIconMap } from '../enums/chart-icon.enum';
import { BlockModel } from '@Common/PageBuilder/models/block.model';
import { Am5ChartBlockComponent } from '../components/Am5ChartBlock/am5-chart-block.component';
import { ProminenceTakeOverPanelComponent } from '../../../Account/AccountPreferences/components/ProminenceTakeOverPanel/prominence-take-over-panel.component';

function analysisMetricBreakdownColors(n: number): ChartColorPickerFieldModel[] {
    return Array.from(Array(n)).map((_, i) => {
        const v = i + 1;
        return new ChartColorPickerFieldModel(
            ChartColorPickerFieldComponent,
            {
                property: 'styles.colorMap.analysisColor' + v,
                key: 'metric' + i,
                label: 'Reports.formField.metadata.metric' + v,
                description: '',
                dialogHeading: '',
                doBorder: true,
                showRecentColors: true
            },
            { colorType: 'generalColors', typeProperty: ('color' + v) as keyof UserAppPreferenceChartColors['generalColors'] },
        );
    });
}

export const coverageOverTimeBlockType: BlockTypeModel = new BlockTypeModel(
    ReportBlockTypeEnum.COVERAGE_OVER_TIME,
    `Reports.chart.title.${ReportBlockTypeEnum.COVERAGE_OVER_TIME}`,
    'fa-regular fa-duotone fa-chart-line',
    'Chart goes here!',
    ChartDisplayElementModel,
    [
        new TextFieldModel(
            TextFieldComponent,
            'title',
            'Reports.formField.chartTitle',
            null,
            false,
            64,
            'Reports.formField.chartTitle.placeholder'
        ),
        new DateRangeFieldModel(
            DateRangeFieldComponent,
            'series',
            'Reports.formField.dateRange.label',
            ''
        ),
        new DropdownFieldModel(
            TimeIntervalDropdownFieldComponent,
            'timeInterval',
            'Reports.formField.timeInterval.label',
            '',
            [
                new DropdownOptionModel(`Reports.timeInterval.${ChartTimeIntervalsEnum.DYNAMIC}`, ChartTimeIntervalsEnum.DYNAMIC),
                new DropdownOptionModel(`Reports.timeInterval.${ChartTimeIntervalsEnum.WEEK}`, ChartTimeIntervalsEnum.WEEK),
                new DropdownOptionModel(`Reports.timeInterval.${ChartTimeIntervalsEnum.MONTH}`, ChartTimeIntervalsEnum.MONTH),
                new DropdownOptionModel(`Reports.timeInterval.${ChartTimeIntervalsEnum.QUARTER}`, ChartTimeIntervalsEnum.QUARTER),
                new DropdownOptionModel(`Reports.timeInterval.${ChartTimeIntervalsEnum.YEAR}`, ChartTimeIntervalsEnum.YEAR),
            ],
            '',
            'Time Interval'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.analysis',
            'analysis_heading'
        ),
        new ChartAnalysisMetricDropdownFieldModel(
            MultipleMetricsPickerComponent,
            'metrics',
            '',
            '',
            [
                new DropdownOptionModel('Reports.analysis.type.mentions', ChartMetricsEnum.volumeOfMentions),
                new DropdownOptionModel('Reports.analysis.type.ave', ChartMetricsEnum.ave),
                new DropdownOptionModel(`Reports.analysis.type.${SocialSeriesMetricsEnum.IMPRESSIONS}`, ChartMetricsEnum.IMPRESSIONS),
                new DropdownOptionModel(`Reports.analysis.type.${SocialSeriesMetricsEnum.ENGAGEMENTS}`, ChartMetricsEnum.ENGAGEMENTS),
                new DropdownOptionModel(`Reports.analysis.type.${SocialSeriesMetricsEnum.ENGAGEMENT_RATE}`, ChartMetricsEnum.ENGAGEMENT_RATE),
                new DropdownOptionModel(`Reports.analysis.type.${SocialSeriesMetricsEnum.APPLAUSE}`, ChartMetricsEnum.APPLAUSE),
                new DropdownOptionModel(`Reports.analysis.type.${SocialSeriesMetricsEnum.CONVERSATION}`, ChartMetricsEnum.CONVERSATION),
                new DropdownOptionModel(`Reports.analysis.type.${SocialSeriesMetricsEnum.AMPLIFICATION}`, ChartMetricsEnum.AMPLIFICATION),
                new DropdownOptionModel(`Reports.analysis.type.${SocialSeriesMetricsEnum.VIEWS}`, ChartMetricsEnum.VIEWS),
            ],
            'Reports.analysis.select',
            {
                maxNumberOfMetrics: 4
            },
            'analysis_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.dataSource.singleSeries.label',
            'dataSource_heading'
        ),
        new SeriesPickerFieldModel(
            SeriesPickerFieldComponent,
            'series',
            '',
            '',
            false,
            1,
            [
                ...mentionSeriesTypes,
                ...socialSeriesTypes
            ],
            socialSeriesFilterTypes,
            [],
            false,
            false,
            false,
            'dataSource_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.term.chartType',
            'chartType_heading'
        ),
        new RadioButtonsFieldModel(
            RadioButtonsFieldComponent,
            'chartSpecificType',
            '',
            false,
            [
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.LINE}`, ChartSpecificTypesEnum.LINE, false, '',
                    [
                        new RadioButtonOptionModel('Report.chartStyle.filled', ChartSpecificTypesEnum.FILLED_LINE),
                        new RadioButtonOptionModel('Report.chartStyle.notFilled', ChartSpecificTypesEnum.LINE)
                    ]
                ),
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.COLUMN}`, ChartSpecificTypesEnum.COLUMN)
            ],
            true,
            'chartSpecificType'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formfield.metadata.colorSettings'
        ),
        ...analysisMetricBreakdownColors(4),
        new ChartDisplaySettingsFieldModel(
            'chartHeaderSettings',
            ChartDisplaySettingsFieldComponent,
            'Reports.chartSetupDialog.displaySettings'

        ),
        new PREventsFieldModel(
            PREventsFieldComponent,
            'prevents',
            'Reports.chartSetupDialog.prEvents'
        )
    ],
    Am5ChartBlockComponent
);

export const sentimentBreakdownBlockType: BlockTypeModel = new BlockTypeModel(
    ReportBlockTypeEnum.SENTIMENT_BREAKDOWN,
    `Reports.chart.title.${ReportBlockTypeEnum.SENTIMENT_BREAKDOWN}`,
    'fa-regular fa-duotone fa-chart-pie',
    'Chart goes here!',
    ChartDisplayElementModel,
    [
        new TextFieldModel(
            TextFieldComponent,
            'title',
            'Reports.formField.chartTitle',
            null,
            false,
            64,
            'Reports.formField.chartTitle.placeholder'
        ),
        new DateRangeFieldModel(
            DateRangeFieldComponent,
            'series',
            'Reports.formField.dateRange.label',
            ''
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.dataSource.singleSeries.label',
            'source_heading'
        ),
        new SeriesPickerFieldModel(
            SeriesPickerFieldComponent,
            'series',
            '',
            '',
            false,
            undefined,
            [
                ...mentionSeriesTypes,
                ...socialSeriesTypes
            ],
            socialSeriesFilterTypes,
            undefined,
            false,
            false,
            false,
            'source_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.term.chartType',
            'chartType_heading'
        ),
        new RadioButtonsFieldModel(
            RadioButtonsFieldComponent,
            'chartSpecificType',
            '',
            false,
            [
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.PIE}`, ChartSpecificTypesEnum.PIE),
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.COLUMN}`, ChartSpecificTypesEnum.MULTI_STACKED_COLUMN, false, '',
                    [
                        new RadioButtonOptionModel('Reports.chartSetupDialog.stacked', ChartSpecificTypesEnum.MULTI_STACKED_COLUMN),
                        new RadioButtonOptionModel('Reports.chartSetupDialog.clustered', ChartSpecificTypesEnum.COLUMN),
                    ]
                ),
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.BAR}`, ChartSpecificTypesEnum.MULTI_STACKED_BAR, false, '',
                    [
                        new RadioButtonOptionModel('Reports.chartSetupDialog.stacked', ChartSpecificTypesEnum.MULTI_STACKED_BAR),
                        new RadioButtonOptionModel('Reports.chartSetupDialog.clustered', ChartSpecificTypesEnum.BAR),
                    ]
                )
            ],
            true,
            'chartSpecificType'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.chartSetupDialog.dataDisplaySettings',
            'displaySettings_heading'
        ),
        new CheckboxesFieldModel(
            ChartDataDisplaySettingsCheckboxFieldComponent,
            'labelDisplayOptions',
            '',
            '',
            [
                new CheckboxOptionModel('Reports.formfield.displayPercentage.label', LabelDisplayOptionsEnum.percent),
                new CheckboxOptionModel('Reports.formfield.displayCount.label', LabelDisplayOptionsEnum.count)
            ],
            false,
            'displaySettings_heading',
            null,
            (displayElement: ChartDisplayElementModel) => displayElement.chartSpecificType === ChartSpecificTypesEnum.COLUMN,
            'Reports.formField.noLabelsForColumnCharts'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formfield.metadata.label',
            'metadata_heading'
        ),
        new ChartColorCheckboxesFieldModel(
            ChartColorCheckboxesFieldComponent,
            'sentiments',
            '',
            '',
            [
                new ChartColorCheckboxOptionModel(
                    'Reports.sentiment.positive',
                    SearchCriteriaQuerySentimentsEnum.positive,
                    { colorType: 'sentimentColors', typeProperty: 'positive' },
                    false,
                    null,
                ),
                new ChartColorCheckboxOptionModel(
                    'Reports.sentiment.neutral',
                    SearchCriteriaQuerySentimentsEnum.neutral,
                    { colorType: 'sentimentColors', typeProperty: 'neutral' },
                    false,
                    null,
                ),
                new ChartColorCheckboxOptionModel(
                    'Reports.sentiment.negative',
                    SearchCriteriaQuerySentimentsEnum.negative,
                    { colorType: 'sentimentColors', typeProperty: 'negative' },
                    false,
                    null,
                ),
                new ChartColorCheckboxOptionModel(
                    'Reports.sentiment.notAvailable',
                    SearchCriteriaQuerySentimentsEnum.notAvailable,
                    { colorType: 'sentimentColors', typeProperty: 'notAvailable' },
                    false,
                    null,
                )
            ],
            null,
            'Reports.formField.atLeastOneSentiment.label',
            'metadata_heading'
        ),
        new ChartDisplaySettingsFieldModel(
            'chartHeaderSettings',
            ChartDisplaySettingsFieldComponent,
            'Reports.chartSetupDialog.displaySettings'
        )
    ],
    ChartBlockComponent
);

export const sentimentTrendBlockType: BlockTypeModel = new BlockTypeModel(
    ReportBlockTypeEnum.SENTIMENT_TREND,
    `Reports.chart.title.${ReportBlockTypeEnum.SENTIMENT_TREND}`,
    'fa-regular fa-duotone fa-chart-line',
    'Chart goes here!',
    ChartDisplayElementModel,
    [
        new TextFieldModel(
            TextFieldComponent,
            'title',
            'Reports.formField.chartTitle',
            null,
            false,
            64,
            'Reports.formField.chartTitle.placeholder'
        ),
        new DateRangeFieldModel(
            DateRangeFieldComponent,
            'series',
            'Reports.formField.dateRange.label',
            ''
        ),
        new DropdownFieldModel(
            TimeIntervalDropdownFieldComponent,
            'timeInterval',
            'Reports.formField.timeInterval.label',
            '',
            [
                new DropdownOptionModel(`Reports.timeInterval.${ChartTimeIntervalsEnum.DYNAMIC}`, ChartTimeIntervalsEnum.DYNAMIC),
                new DropdownOptionModel(`Reports.timeInterval.${ChartTimeIntervalsEnum.WEEK}`, ChartTimeIntervalsEnum.WEEK),
                new DropdownOptionModel(`Reports.timeInterval.${ChartTimeIntervalsEnum.MONTH}`, ChartTimeIntervalsEnum.MONTH),
                new DropdownOptionModel(`Reports.timeInterval.${ChartTimeIntervalsEnum.QUARTER}`, ChartTimeIntervalsEnum.QUARTER),
                new DropdownOptionModel(`Reports.timeInterval.${ChartTimeIntervalsEnum.YEAR}`, ChartTimeIntervalsEnum.YEAR),
            ],
            '',
            'Time Interval'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.dataSource.singleSeries.label',
            'dataSource_heading'
        ),
        new SeriesPickerFieldModel(
            SeriesPickerFieldComponent,
            'series',
            '',
            '',
            false,
            undefined,
            [
                ...mentionSeriesTypes,
                ...socialSeriesTypes
            ],
            socialSeriesFilterTypes,
            undefined,
            false,
            false,
            false,
            'dataSource_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.term.chartType',
        ),
        new RadioButtonsFieldModel(
            RadioButtonsFieldComponent,
            'stackedChartTypes',
            '',
            false,
            [
                new RadioButtonOptionModel(`Reports.stacked.type.${StackedChartTypesEnum.PERCENTAGE}`, StackedChartTypesEnum.PERCENTAGE),
                new RadioButtonOptionModel(`Reports.stacked.type.${StackedChartTypesEnum.VOLUME}`, StackedChartTypesEnum.VOLUME)
            ],
            true,
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formfield.metadata.label',
            'metadata_heading'
        ),
        new ChartColorCheckboxesFieldModel(
            ChartColorCheckboxesFieldComponent,
            'sentiments',
            '',
            '',
            [
                new ChartColorCheckboxOptionModel(
                    'Reports.sentiment.positive',
                    SearchCriteriaQuerySentimentsEnum.positive,
                    { colorType: 'sentimentColors', typeProperty: 'positive' },
                    false,
                    null,
                ),
                new ChartColorCheckboxOptionModel(
                    'Reports.sentiment.neutral',
                    SearchCriteriaQuerySentimentsEnum.neutral,
                    { colorType: 'sentimentColors', typeProperty: 'neutral' },
                    false,
                    null,
                ),
                new ChartColorCheckboxOptionModel(
                    'Reports.sentiment.negative',
                    SearchCriteriaQuerySentimentsEnum.negative,
                    { colorType: 'sentimentColors', typeProperty: 'negative' },
                    false,
                    null,
                ),
                new ChartColorCheckboxOptionModel(
                    'Reports.sentiment.notAvailable',
                    SearchCriteriaQuerySentimentsEnum.notAvailable,
                    { colorType: 'sentimentColors', typeProperty: 'notAvailable' },
                    false,
                    null,
                )
            ],
            false,
            null,
            'metadata_heading'
        ),
        new ChartDisplaySettingsFieldModel(
            'chartHeaderSettings',
            ChartDisplaySettingsFieldComponent,
            'Reports.chartSetupDialog.displaySettings'
        )
    ],
    Am5ChartBlockComponent
);

export const mediaTypeBreakdownBlockType: BlockTypeModel = new BlockTypeModel(
    ReportBlockTypeEnum.MEDIA_TYPE_BREAKDOWN,
    `Reports.chart.title.${ReportBlockTypeEnum.MEDIA_TYPE_BREAKDOWN}`,
    'fa-regular fa-duotone fa-chart-pie',
    'Chart goes here!',
    ChartDisplayElementModel,
    [
        new TextFieldModel(
            TextFieldComponent,
            'title',
            'Reports.formField.chartTitle',
            null,
            false,
            64,
            'Reports.formField.chartTitle.placeholder'
        ),
        new DateRangeFieldModel(
            DateRangeFieldComponent,
            'series',
            'Reports.formField.dateRange.label',
            ''
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.dataSource.singleSeries.label',
            'dataSource_heading'
        ),
        new SeriesPickerFieldModel(
            SeriesPickerFieldComponent,
            'series',
            '',
            '',
            false,
            undefined,
            [
                ...mentionSeriesTypes,
                ...socialSeriesTypes
            ],
            undefined,
            undefined,
            false,
            false,
            false,
            'dataSource_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.term.chartType',
            'chartType_heading'
        ),
        new RadioButtonsFieldModel(
            RadioButtonsFieldComponent,
            'chartSpecificType',
            '',
            false,
            [
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.PIE}`, ChartSpecificTypesEnum.PIE),
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.COLUMN}`, ChartSpecificTypesEnum.MULTI_STACKED_COLUMN, false, '',
                    [
                        new RadioButtonOptionModel('Reports.chartSetupDialog.stacked', ChartSpecificTypesEnum.MULTI_STACKED_COLUMN),
                        new RadioButtonOptionModel('Reports.chartSetupDialog.clustered', ChartSpecificTypesEnum.COLUMN),
                    ]
                ),
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.BAR}`, ChartSpecificTypesEnum.MULTI_STACKED_BAR, false, '',
                    [
                        new RadioButtonOptionModel('Reports.chartSetupDialog.stacked', ChartSpecificTypesEnum.MULTI_STACKED_BAR),
                        new RadioButtonOptionModel('Reports.chartSetupDialog.clustered', ChartSpecificTypesEnum.BAR),
                    ]
                )
            ],
            true,
            'chartSpecificType'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.chartSetupDialog.dataDisplaySettings',
            'displaySettings_heading'
        ),
        new CheckboxesFieldModel(
            ChartDataDisplaySettingsCheckboxFieldComponent,
            'labelDisplayOptions',
            '',
            '',
            [
                new CheckboxOptionModel('Reports.formfield.displayPercentage.label', LabelDisplayOptionsEnum.percent),
                new CheckboxOptionModel('Reports.formfield.displayCount.label', LabelDisplayOptionsEnum.count)
            ],
            false,
            'displaySettings_heading',
            null,
            (displayElement: ChartDisplayElementModel) => displayElement.chartSpecificType === ChartSpecificTypesEnum.COLUMN,
            'Reports.formField.noLabelsForColumnCharts'
        ),
        new ChartDisplaySettingsFieldModel(
            'chartHeaderSettings',
            ChartDisplaySettingsFieldComponent,
            'Reports.chartSetupDialog.displaySettings'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formfield.metadata.mediaTypes',
            'colorSettings_heading'
        ),
        new MediaTypeColorPickerWrapperFieldModel(
            OptionalMediaTypeColorPickerFieldComponent,
            'styles.colorMap',
            MediaTypeCollectionTypesEnum.ALL,
            'colorSettings_heading'
        )
    ],
    ChartBlockComponent
);

const geographyBreakdownColors: ChartColorPickerFieldModel[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(
    n => {
        return new ChartColorPickerFieldModel(
            ChartColorPickerFieldComponent,
            {
                property: 'styles.colorMap.region' + n,
                key: 'region' + n,
                label: 'Reports.formField.metadata.region' + n,
                description: '',
                dialogHeading: '',
                doBorder: true,
                showRecentColors: true
            },
            { colorType: 'generalColors', typeProperty: ('color' + n) as keyof UserAppPreferenceChartColors['generalColors'] },
            `regionColor${n}_heading`,
            (displayElement: ChartDisplayElementModel) => {
                return displayElement.chartSpecificType === ChartSpecificTypesEnum.MAP
                    && displayElement.mapChartColorScheme === MapChartColorSchemeEnum.REGION_COLORS;
            }
        );
    }
);
export const geographyBreakdownBlockType: BlockTypeModel = new BlockTypeModel(
    ReportBlockTypeEnum.GEOGRAPHY_BREAKDOWN_BY_VOLUME,
    `Reports.chart.title.${ReportBlockTypeEnum.GEOGRAPHY_BREAKDOWN_BY_VOLUME}`,
    'fa-regular fa-duotone fa-location-dot',
    'Chart goes here!',
    ChartDisplayElementModel,
    [
        new TextFieldModel(
            TextFieldComponent,
            'title',
            'Reports.formField.chartTitle',
            null,
            false,
            64,
            'Reports.formField.chartTitle.placeholder'
        ),
        new DateRangeFieldModel(
            DateRangeFieldComponent,
            'series',
            'Reports.formField.dateRange.label',
            ''
        ),
        new RegionPickerFieldModel(
            RegionPickerFieldComponent,
            'series',
            '',
            ''
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.analysis',
            'analysis_heading'
        ),
        new ChartAnalysisMetricDropdownFieldModel(
            MetricPickerComponent,
            'metric',
            '',
            '',
            [
                new DropdownOptionModel('Reports.analysis.type.mentions', ChartMetricsEnum.volumeOfMentions),
                new DropdownOptionModel(`Reports.analysis.type.${SocialSeriesMetricsEnum.IMPRESSIONS}`, ChartMetricsEnum.IMPRESSIONS),
                new DropdownOptionModel('Reports.analysis.type.ave', ChartMetricsEnum.ave)
            ],
            'Reports.analysis.select',
            undefined,
            'analysis_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.dataSource.singleSeries.label',
            'dataSource_heading'
        ),
        new SeriesPickerFieldModel(
            SeriesPickerFieldComponent,
            'series',
            '',
            '',
            false,
            1,
            [
                ...mentionSeriesTypes,
                ...socialSeriesTypes
            ],
            [
                SeriesFilterTypesEnum.keywords,
                SeriesFilterTypesEnum.authors,
                SeriesFilterTypesEnum.outlets,
                SeriesFilterTypesEnum.audience,
                SeriesFilterTypesEnum.ave,
                SeriesFilterTypesEnum.sentiment,
                SeriesFilterTypesEnum.mediaTypes,
                SeriesFilterTypesEnum.languages,
                SeriesFilterTypesEnum.duplicates,
                SeriesFilterTypesEnum.aiAgents,
                SeriesFilterTypesEnum.tags,
                SeriesFilterTypesEnum.tagGroups,
                SeriesFilterTypesEnum.sourceGroups,
                SeriesFilterTypesEnum.agents,
                SeriesFilterTypesEnum.engagement,
                SeriesFilterTypesEnum.engagementRate,
                SeriesFilterTypesEnum.hashtags,
            ],
            undefined,
            false,
            false,
            false,
            'dataSource_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.term.chartType',
            'chartType_heading'
        ),
        new RadioButtonsFieldModel(
            RadioButtonsFieldComponent,
            'chartSpecificType',
            '',
            false,
            [
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.MAP}`, ChartSpecificTypesEnum.MAP),
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.BAR}`, ChartSpecificTypesEnum.BAR),
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.COLUMN}`, ChartSpecificTypesEnum.COLUMN)
            ],
            true,
            'chartSpecificType'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.mapChartColorScheme.heading',
            'mapChartColorScheme_heading',
            (displayElement: ChartDisplayElementModel) => {
                return displayElement.chartSpecificType === ChartSpecificTypesEnum.MAP;
            }
        ),
        new RadioButtonsFieldModel(
            RadioButtonsFieldComponent,
            'mapChartColorScheme',
            '',
            false,
            [
                new RadioButtonOptionModel('Reports.mapChartColorScheme.choropleth', MapChartColorSchemeEnum.CHOROPLETH),
                new RadioButtonOptionModel('Reports.mapChartColorScheme.regionColors', MapChartColorSchemeEnum.REGION_COLORS)
            ],
            false,
            'mapChartColorScheme_radioButtons',
            (displayElement: ChartDisplayElementModel) => {
                return displayElement.chartSpecificType === ChartSpecificTypesEnum.MAP;
            }
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.chartSetupDialog.dataDisplaySettings',
            'displaySettings_heading'
        ),
        new CheckboxesFieldModel(
            CheckboxesFieldComponent,
            'labelDisplayOptions',
            '',
            '',
            [
                new CheckboxOptionModel('Reports.formfield.displayPercentage.label', LabelDisplayOptionsEnum.percent),
                new CheckboxOptionModel('Reports.formfield.displayCount.label', LabelDisplayOptionsEnum.count)
            ],
            false,
            'displaySettings_heading'
        ),
        new ChartDisplaySettingsFieldModel(
            'chartHeaderSettings',
            ChartDisplaySettingsFieldComponent,
            'Reports.chartSetupDialog.displaySettings'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formfield.metadata.colorSettings'
        ),
        ...geographyBreakdownColors,
        new DropdownFieldModel(
            DropdownFieldComponent,
            'mapChartChoroplethInterpolationType',
            'Reports.mapChartColorScheme.interpolationType',
            '',
            [
                new DropdownOptionModel('Reports.mapChartColorScheme.interpolationType.linear', MapChartChoroplethInterpolationTypeEnum.LINEAR),
                new DropdownOptionModel('Reports.mapChartColorScheme.interpolationType.logarithmic', MapChartChoroplethInterpolationTypeEnum.LOGARITHMIC)
            ],
            '',
            '',
            (displayElement: ChartDisplayElementModel) => {
                const mapChartColorScheme = displayElement.mapChartColorScheme;
                return displayElement.chartSpecificType === ChartSpecificTypesEnum.MAP
                    && (!mapChartColorScheme || mapChartColorScheme === MapChartColorSchemeEnum.CHOROPLETH);
            }
        ),
        new ChartColorPickerFieldModel(
            ChartColorPickerFieldComponent,
            {
                property: 'styles.colorMap.choroplethHighValue',
                key: 'highValue',
                label: 'Reports.mapChartColorScheme.highValue',
                description: '',
                dialogHeading: '',
                doBorder: true,
                showRecentColors: true
            },
            { colorType: 'generalColors', typeProperty: ('color1') as keyof UserAppPreferenceChartColors['generalColors'] },
            'choroplethHighValue_heading',
            (displayElement: ChartDisplayElementModel) => {
                return displayElement.chartSpecificType === ChartSpecificTypesEnum.MAP
                    && displayElement.mapChartColorScheme === MapChartColorSchemeEnum.CHOROPLETH;
            }
        ),
        new ChartColorPickerFieldModel(
            ChartColorPickerFieldComponent,
            {
                property: 'styles.colorMap.choroplethLowValue',
                key: 'lowValue',
                label: 'Reports.mapChartColorScheme.lowValue',
                description: '',
                dialogHeading: '',
                doBorder: true,
                showRecentColors: true
            },
            { colorType: 'generalColors', typeProperty: ('color2') as keyof UserAppPreferenceChartColors['generalColors'] },
            'choroplethLowValue_heading',
            (displayElement: ChartDisplayElementModel) => {
                return displayElement.chartSpecificType === ChartSpecificTypesEnum.MAP
                    && displayElement.mapChartColorScheme === MapChartColorSchemeEnum.CHOROPLETH;
            }
        ),
        new ColorPickerFieldModel(
            ColorPickerFieldComponent,
            'styles.colorMap.other',
            'other',
            'Common.other',
            '',
            '',
            null,
            chartColors.agprOther,
            true,
            false,
            (displayElement: DisplayElementModel) => {
                return (displayElement as ChartDisplayElementModel).chartSpecificType === ChartSpecificTypesEnum.MAP;
            }
        ),
        new ChartColorPickerFieldModel(
            ChartColorPickerFieldComponent,
            {
                property: 'styles.colorMap.barColor',
                key: 'seriesColor0',
                label: 'Reports.chartSetupDialog.barColor',
                description: '',
                dialogHeading: '',
                doBorder: true,
                showRecentColors: true
            },
            { colorType: 'barColors', typeProperty: 'barColor' },
            'barColor_heading',
            (displayElement: ChartDisplayElementModel) => displayElement.chartSpecificType !== ChartSpecificTypesEnum.MAP
        )
    ],
    ChartBlockComponent
);
export const outletsBreakdownBlockType: BlockTypeModel = new BlockTypeModel(
    ReportBlockTypeEnum.TOP_10_OUTLETS,
    `Reports.chart.title.${ReportBlockTypeEnum.TOP_10_OUTLETS}`,
    'fa-regular fa-duotone fa-chart-column',
    'Chart goes here!',
    ChartDisplayElementModel,
    [
        new TextFieldModel(
            TextFieldComponent,
            'title',
            'Reports.formField.chartTitle',
            null,
            false,
            64,
            'Reports.formField.chartTitle.placeholder'
        ),
        new DateRangeFieldModel(
            DateRangeFieldComponent,
            'series',
            'Reports.formField.dateRange.label',
            ''
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.analysis',
            'analysis_heading'
        ),
        new ChartAnalysisMetricDropdownFieldModel(
            MetricPickerComponent,
            'metric',
            '',
            '',
            [
                new DropdownOptionModel('Reports.analysis.type.volumeOfMentions', ChartMetricsEnum.volumeOfMentions),
                new DropdownOptionModel('Reports.analysis.type.audienceReach', ChartMetricsEnum.IMPRESSIONS),
                new DropdownOptionModel('Reports.analysis.type.ave', ChartMetricsEnum.ave),
                new DropdownOptionModel('Reports.analysis.type.domainAuthority', ChartMetricsEnum.domainAuthority)
            ],
            'Reports.analysis.select',
            undefined,
            'analysis_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.dataSource.singleSeries.label',
            'dataSource_heading'
        ),
        new SeriesPickerFieldModel(
            SeriesPickerFieldComponent,
            'series',
            '',
            '',
            false,
            undefined,
            [
                ...mentionSeriesTypes,
                ...socialSeriesTypes
            ],
            undefined,
            undefined,
            false,
            true,
            false,
            'dataSource_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.term.chartType',
            'chartType_heading'
        ),
        new RadioButtonsFieldModel(
            RadioButtonsFieldComponent,
            'chartSpecificType',
            '',
            false,
            [
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.BAR}`, ChartSpecificTypesEnum.BAR),
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.COLUMN}`, ChartSpecificTypesEnum.COLUMN)
            ],
            true,
            'chartSpecificType'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.chartSetupDialog.dataDisplaySettings',
            'displaySettings_heading',
        ),
        new CheckboxesFieldModel(
            ChartDataDisplaySettingsCheckboxFieldComponent,
            'labelDisplayOptions',
            '',
            '',
            [
                new CheckboxOptionModel('Reports.formfield.displayPercentage.label', LabelDisplayOptionsEnum.percent),
                new CheckboxOptionModel('Reports.formfield.displayCount.label', LabelDisplayOptionsEnum.count)
            ],
            false,
            'displaySettings_heading',
            null,
            (displayElement: ChartDisplayElementModel) => displayElement.chartSpecificType === ChartSpecificTypesEnum.COLUMN,
            'Reports.formField.noLabelsForColumnCharts',
            (displayElement: ChartDisplayElementModel) => {
                if (displayElement.metric === ChartMetricsEnum.domainAuthority) {
                    return LabelDisplayOptionsEnum.percent;
                }
            }
        ),
        new ChartDisplaySettingsFieldModel(
            'chartHeaderSettings',
            ChartDisplaySettingsFieldComponent,
            'Reports.chartSetupDialog.displaySettings',
            '',
            null,
            false,
            false,
            null,
            EntityType.OUTLET
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formfield.metadata.colorSettings'
        ),
        new ChartColorPickerFieldModel(
            ChartColorPickerFieldComponent,
            {
                property: 'styles.colorMap.barColor',
                key: 'seriesColor0',
                label: 'Reports.chartSetupDialog.barColor',
                description: '',
                dialogHeading: '',
                doBorder: true,
                showRecentColors: true
            },
            { colorType: 'barColors', typeProperty: 'barColor' }
        ),
    ],
    Am5ChartBlockComponent
);

const shareOfVoiceSubSourceColors: ChartColorPickerFieldModel[] = Array.from({length: 12}, (_, i) => i + 1).map(
    n => {
        return new ChartColorPickerFieldModel(
            ChartColorPickerFieldComponent,
            {
                property: 'styles.colorMap.subSource' + n,
                key: 'subSource' + n,
                label: 'Reports.formField.metadata.tag' + n,
                description: '',
                dialogHeading: '',
                doBorder: true,
                showRecentColors: true
            },
            { colorType: 'generalColors', typeProperty: ('color' + n) as keyof UserAppPreferenceChartColors['generalColors'] },
        );
    }
);
export const shareOfVoiceBlockType: BlockTypeModel = new BlockTypeModel(
    ReportBlockTypeEnum.SHARE_OF_VOICE,
    `Reports.chart.title.${ReportBlockTypeEnum.SHARE_OF_VOICE}`,
    'fa-regular fa-duotone fa-chart-pie',
    'Chart goes here!',
    ChartDisplayElementModel,
    [
        new TextFieldModel(
            TextFieldComponent,
            'title',
            'Reports.formField.chartTitle',
            null,
            false,
            64,
            'Reports.formField.chartTitle.placeholder'
        ),
        new DateRangeFieldModel(
            DateRangeFieldComponent,
            'series',
            'Reports.formField.dateRange.label',
            ''
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.analysis',
            'analysis_heading'
        ),
        new ChartAnalysisMetricDropdownFieldModel(
            MetricPickerComponent,
            'metric',
            '',
            '',
            [
                new DropdownOptionModel('Reports.analysis.type.mentions', ChartMetricsEnum.volumeOfMentions),
                new DropdownOptionModel('Reports.analysis.type.ave', ChartMetricsEnum.ave),
                new DropdownOptionModel('Reports.analysis.type.audienceReach', ChartMetricsEnum.IMPRESSIONS),
                new DropdownOptionModel('Reports.analysis.type.engagements', ChartMetricsEnum.ENGAGEMENTS),
                new DropdownOptionModel(`Reports.analysis.type.${SocialSeriesMetricsEnum.APPLAUSE}`, ChartMetricsEnum.APPLAUSE),
                new DropdownOptionModel(`Reports.analysis.type.${SocialSeriesMetricsEnum.CONVERSATION}`, ChartMetricsEnum.CONVERSATION),
                new DropdownOptionModel(`Reports.analysis.type.${SocialSeriesMetricsEnum.AMPLIFICATION}`, ChartMetricsEnum.AMPLIFICATION),
                new DropdownOptionModel(`Reports.analysis.type.${SocialSeriesMetricsEnum.VIEWS}`, ChartMetricsEnum.VIEWS),
            ],
            'Reports.analysis.select',
            undefined,
            'analysis_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.dataSource.multiSeries.label',
            'dataSource_heading'
        ),
        new SeriesPickerCompareFieldModel(
            SeriesPickerCompareFieldComponent,
            'series',
            '',
            '',
            [
                ...mentionSeriesTypes,
                ...socialSeriesTypes
            ],
            [],
            true,
            false,
            false,
            'dataSource_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.term.chartType',
            'chartType_heading'
        ),
        new RadioButtonsFieldModel(
            RadioButtonsFieldComponent,
            'chartSpecificType',
            '',
            false,
            [
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.PIE}`, ChartSpecificTypesEnum.PIE),
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.COLUMN}`, ChartSpecificTypesEnum.MULTI_STACKED_COLUMN, false, '',
                    [
                        new RadioButtonOptionModel('Reports.chartSetupDialog.stacked', ChartSpecificTypesEnum.MULTI_STACKED_COLUMN),
                        new RadioButtonOptionModel('Reports.chartSetupDialog.clustered', ChartSpecificTypesEnum.COLUMN),
                    ]
                ),
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.BAR}`, ChartSpecificTypesEnum.MULTI_STACKED_BAR, false, '',
                    [
                        new RadioButtonOptionModel('Reports.chartSetupDialog.stacked', ChartSpecificTypesEnum.MULTI_STACKED_BAR),
                        new RadioButtonOptionModel('Reports.chartSetupDialog.clustered', ChartSpecificTypesEnum.BAR),
                    ]
                )
            ],
            true,
            'chartSpecificType'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.chartSetupDialog.dataDisplaySettings',
            'displaySettings_heading'
        ),
        new CheckboxesFieldModel(
            ChartDataDisplaySettingsCheckboxFieldComponent,
            'labelDisplayOptions',
            '',
            '',
            [
                new CheckboxOptionModel('Reports.formfield.displayPercentage.label', LabelDisplayOptionsEnum.percent),
                new CheckboxOptionModel('Reports.formfield.displayCount.label', LabelDisplayOptionsEnum.count)
            ],
            false,
            'displaySettings_heading',
            null,
            (displayElement: ChartDisplayElementModel) => displayElement.chartSpecificType === ChartSpecificTypesEnum.COLUMN,
            'Reports.formField.noLabelsForColumnCharts'
        ),
        new ChartDisplaySettingsFieldModel(
            'chartHeaderSettings',
            ChartDisplaySettingsFieldComponent,
            'Reports.chartSetupDialog.displaySettings',
            undefined,
            undefined,
            true,
            true,
            (displayElement: ChartDisplayElementModel) => displayElement.chartSpecificType === ChartSpecificTypesEnum.BAR
        ),
        new ConditionalTextHeadingFieldModel(
            ConditionalTextHeadingFieldComponent,
            'Reports.formfield.metadata.colorSettings',
            'subSourceColorSettings_heading',
            function() {
                return (this.block.displayElement as ChartDisplayElementModel).series
                    ?.every(s => !!s.styles?.parentGroupId || !! s.styles?.parentThemeId)
                    || ((this.block.displayElement as ChartDisplayElementModel).chartHeaderSettings?.previousPeriod
                    && ((<ChartDisplayElementModel>this.block.displayElement).chartSpecificType === ChartSpecificTypesEnum.BAR
                    || (<ChartDisplayElementModel>this.block.displayElement).chartSpecificType === ChartSpecificTypesEnum.COLUMN));
            }
        ),
        ...shareOfVoiceSubSourceColors,
        new RadioButtonsFieldModel(
            RadioButtonsFieldComponent,
            'styles.previousPeriodBarColorType',
            'Reports.chartSetupDialog.previousBarColor',
            true,
            [
                new ChartColorRadioOptionModel(
                    'Reports.chartSetupDialog.selectColor',
                    PreviousPeriodBarColorsEnum.CUSTOM,
                    false,
                    '',
                    [
                        new ChartColorRadioOptionModel(
                            '',
                            PreviousPeriodBarColorsEnum.CUSTOM,
                            false,
                            '',
                            [],
                            (displayElement: ChartDisplayElementModel) => true,
                            false,
                            [
                                new ChartColorPickerFieldModel(
                                    ChartColorPickerFieldComponent,
                                    {
                                        property: 'styles.colorMap.previousPeriodBarColor',
                                        key: 'previousPeriodBarColor',
                                        label: '',
                                        description: '',
                                        dialogHeading: '',
                                        doBorder: true,
                                        showRecentColors: true
                                    },
                                    { colorType: 'barColors', typeProperty: 'previousBarColor' },
                                    'previousBar_selectColor',
                                    (displayElement: DisplayElementModel) => true
                                )
                            ]
                        )
                    ],
                    (displayElement: ChartDisplayElementModel) => true,
                    false
                ),
                new RadioButtonOptionModel(
                    'Reports.chartSetupDialog.useBarColor',
                    PreviousPeriodBarColorsEnum.USE_BAR
                )
            ],
            false,
            'previousBarColor_radioButtons',
            (displayElement: DisplayElementModel) => {
                return (<ChartDisplayElementModel>displayElement).chartHeaderSettings.previousPeriod
                    && ((<ChartDisplayElementModel>displayElement).chartSpecificType === ChartSpecificTypesEnum.BAR
                    || (<ChartDisplayElementModel>displayElement).chartSpecificType === ChartSpecificTypesEnum.COLUMN);
            },
            'agpr-radioButtonContainer-heading--normal'
        ),
        new ChartColorPickerFieldModel(
            ChartColorPickerFieldComponent,
            {
                property: 'styles.colorMap.uptrendColor',
                key: 'uptrendColor',
                label: 'Reports.chartSetupDialog.uptrend',
                description: '',
                dialogHeading: '',
                doBorder: true,
                showRecentColors: true
            },
            { colorType: 'otherColors', typeProperty: 'uptrendColor' },
            'uptrendColorPicker',
            (displayElement: ChartDisplayElementModel) => {
                return !!displayElement.chartHeaderSettings?.trendIndicators;
            }
        ),
        new ChartColorPickerFieldModel(
            ChartColorPickerFieldComponent,
            {
                property: 'styles.colorMap.downtrendColor',
                key: 'downtrendColor',
                label: 'Reports.chartSetupDialog.downtrend',
                description: '',
                dialogHeading: '',
                doBorder: true,
                showRecentColors: true
            },
            { colorType: 'otherColors', typeProperty: 'downtrendColor' },
            'downtrendColorPicker',
            (displayElement: ChartDisplayElementModel) => {
                return !!displayElement.chartHeaderSettings?.trendIndicators;
            }
        )
    ],
    ChartBlockComponent
);

export const coverageComparisonBlockType = shareOfVoiceBlockType.cloneFields(
    ReportBlockTypeEnum.COVERAGE_COMPARISON,
    `Reports.chart.title.${ReportBlockTypeEnum.COVERAGE_COMPARISON}`,
    'fa-regular fa-chart-column'
);

export const coverageOverTimeComparisonBlockType: BlockTypeModel = new BlockTypeModel(
    ReportBlockTypeEnum.COVERAGE_OVER_TIME_COMPARISON,
    `Reports.chart.title.${ReportBlockTypeEnum.COVERAGE_OVER_TIME_COMPARISON}`,
    'fa-regular fa-duotone fa-chart-line',
    'Chart goes here!',
    ChartDisplayElementModel,
    [
        new TextFieldModel(
            TextFieldComponent,
            'title',
            'Reports.formField.chartTitle',
            null,
            false,
            64,
            'Reports.formField.chartTitle.placeholder'
        ),
        new DateRangeFieldModel(
            DateRangeFieldComponent,
            'series',
            'Reports.formField.dateRange.label',
            ''
        ),
        new DropdownFieldModel(
            TimeIntervalDropdownFieldComponent,
            'timeInterval',
            'Reports.formField.timeInterval.label',
            '',
            [
                new DropdownOptionModel(`Reports.timeInterval.${ChartTimeIntervalsEnum.DYNAMIC}`, ChartTimeIntervalsEnum.DYNAMIC),
                new DropdownOptionModel(`Reports.timeInterval.${ChartTimeIntervalsEnum.WEEK}`, ChartTimeIntervalsEnum.WEEK),
                new DropdownOptionModel(`Reports.timeInterval.${ChartTimeIntervalsEnum.MONTH}`, ChartTimeIntervalsEnum.MONTH),
                new DropdownOptionModel(`Reports.timeInterval.${ChartTimeIntervalsEnum.QUARTER}`, ChartTimeIntervalsEnum.QUARTER),
                new DropdownOptionModel(`Reports.timeInterval.${ChartTimeIntervalsEnum.YEAR}`, ChartTimeIntervalsEnum.YEAR),
            ],
            '',
            'Time Interval'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.analysis',
            'analysis_heading'
        ),
        new ChartAnalysisMetricDropdownFieldModel(
            MetricPickerComponent,
            'metric',
            '',
            '',
            [
                new DropdownOptionModel('Reports.analysis.type.mentions', ChartMetricsEnum.volumeOfMentions),
                new DropdownOptionModel('Reports.analysis.type.ave', ChartMetricsEnum.ave),
                new DropdownOptionModel(`Reports.analysis.type.${SocialSeriesMetricsEnum.IMPRESSIONS}`, ChartMetricsEnum.IMPRESSIONS),
                new DropdownOptionModel(`Reports.analysis.type.${SocialSeriesMetricsEnum.ENGAGEMENTS}`, ChartMetricsEnum.ENGAGEMENTS),
                new DropdownOptionModel(`Reports.analysis.type.${SocialSeriesMetricsEnum.APPLAUSE}`, ChartMetricsEnum.APPLAUSE),
                new DropdownOptionModel(`Reports.analysis.type.${SocialSeriesMetricsEnum.CONVERSATION}`, ChartMetricsEnum.CONVERSATION),
                new DropdownOptionModel(`Reports.analysis.type.${SocialSeriesMetricsEnum.AMPLIFICATION}`, ChartMetricsEnum.AMPLIFICATION),
                new DropdownOptionModel(`Reports.analysis.type.${SocialSeriesMetricsEnum.VIEWS}`, ChartMetricsEnum.VIEWS),
            ],
            'Reports.analysis.select',
            undefined,
            'analysis_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.dataSource.multiSeries.label',
            'dataSource_heading'
        ),
        new SeriesPickerCompareFieldModel(
            SeriesPickerCompareFieldComponent,
            'series',
            '',
            '',
            [
                ...mentionSeriesTypes,
                ...socialSeriesTypes
            ],
            [],
            true,
            false,
            false,
            'dataSource_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.term.chartType',
            'chartType_heading'
        ),
        new RadioButtonsFieldModel(
            RadioButtonsFieldComponent,
            'chartSpecificType',
            '',
            false,
            [
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.LINE}`, ChartSpecificTypesEnum.LINE, false, '',
                    [
                        new RadioButtonOptionModel('Report.chartStyle.notFilled', ChartSpecificTypesEnum.LINE),
                        new RadioButtonOptionModel('Report.chartStyle.filled', ChartSpecificTypesEnum.FILLED_LINE),
                    ]
                ),
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.COLUMN}`, ChartSpecificTypesEnum.COLUMN)
            ],
            true,
            'chartSpecificType'
        ),
        new ChartDisplaySettingsFieldModel(
            'chartHeaderSettings',
            ChartDisplaySettingsFieldComponent,
            'Reports.chartSetupDialog.displaySettings'
        ),
        new PREventsFieldModel(
            PREventsFieldComponent,
            'prevents',
            'Reports.chartSetupDialog.prEvents'
        )
    ],
    Am5ChartBlockComponent
);

export const sentimentBreakdownComparisonBlockType: BlockTypeModel = new BlockTypeModel(
    ReportBlockTypeEnum.SENTIMENT_BREAKDOWN_COMPARISON,
    `Reports.chart.title.${ReportBlockTypeEnum.SENTIMENT_BREAKDOWN_COMPARISON}`,
    'fa-regular fa-duotone fa-chart-column',
    'Chart goes here!',
    ChartDisplayElementModel,
    [
        new TextFieldModel(
            TextFieldComponent,
            'title',
            'Reports.formField.chartTitle',
            null,
            false,
            64,
            'Reports.formField.chartTitle.placeholder'
        ),
        new DateRangeFieldModel(
            DateRangeFieldComponent,
            'series',
            'Reports.formField.dateRange.label',
            ''
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.dataSource.multiSeries.label',
            'dataSource_heading'
        ),
        new SeriesPickerCompareFieldModel(
            SeriesPickerCompareFieldComponent,
            'series',
            '',
            '',
            [
                ...mentionSeriesTypes,
                ...socialSeriesTypes
            ],
            socialSeriesFilterTypes,
            false,
            false,
            false,
            'dataSource_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.term.chartType',
            'chartType_heading'
        ),
        new RadioButtonsFieldModel(
            RadioButtonsFieldComponent,
            'chartSpecificType',
            '',
            false,
            [
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.COLUMN}`, ChartSpecificTypesEnum.MULTI_STACKED_COLUMN, false, '',
                    [
                        new RadioButtonOptionModel('Reports.chartSetupDialog.stacked', ChartSpecificTypesEnum.MULTI_STACKED_COLUMN),
                        new RadioButtonOptionModel('Reports.chartSetupDialog.clustered', ChartSpecificTypesEnum.COLUMN),
                    ]
                ),
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.BAR}`, ChartSpecificTypesEnum.MULTI_STACKED_BAR, false, '',
                    [
                        new RadioButtonOptionModel('Reports.chartSetupDialog.stacked', ChartSpecificTypesEnum.MULTI_STACKED_BAR),
                        new RadioButtonOptionModel('Reports.chartSetupDialog.clustered', ChartSpecificTypesEnum.BAR),
                    ]
                )
            ],
            true,
            'chartSpecificType'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.chartSetupDialog.dataDisplaySettings',
            'displaySettings_heading'
        ),
        new CheckboxesFieldModel(
            ChartDataDisplaySettingsCheckboxFieldComponent,
            'labelDisplayOptions',
            '',
            '',
            [
                new CheckboxOptionModel('Reports.formfield.displayPercentage.label', LabelDisplayOptionsEnum.percent),
                new CheckboxOptionModel('Reports.formfield.displayCount.label', LabelDisplayOptionsEnum.count)
            ],
            false,
            'displaySettings_heading',
            null,
            (displayElement: ChartDisplayElementModel) => displayElement.chartSpecificType === ChartSpecificTypesEnum.COLUMN,
            'Reports.formField.noLabelsForColumnCharts'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formfield.metadata.label',
            'metadata_heading'
        ),
        new ChartColorCheckboxesFieldModel(
            ChartColorCheckboxesFieldComponent,
            'sentiments',
            '',
            '',
            [
                new ChartColorCheckboxOptionModel(
                    'Reports.sentiment.positive',
                    SearchCriteriaQuerySentimentsEnum.positive,
                    { colorType: 'sentimentColors', typeProperty: 'positive' },
                    false,
                    null,
                ),
                new ChartColorCheckboxOptionModel(
                    'Reports.sentiment.neutral',
                    SearchCriteriaQuerySentimentsEnum.neutral,
                    { colorType: 'sentimentColors', typeProperty: 'neutral' },
                    false,
                    null,
                ),
                new ChartColorCheckboxOptionModel(
                    'Reports.sentiment.negative',
                    SearchCriteriaQuerySentimentsEnum.negative,
                    { colorType: 'sentimentColors', typeProperty: 'negative' },
                    false,
                    null,
                ),
                new ChartColorCheckboxOptionModel(
                    'Reports.sentiment.notAvailable',
                    SearchCriteriaQuerySentimentsEnum.notAvailable,
                    { colorType: 'sentimentColors', typeProperty: 'notAvailable' },
                    false,
                    null,
                )
            ],
            false,
            '',
            'metadata_heading'
        ),
        new ChartDisplaySettingsFieldModel(
            'chartHeaderSettings',
            ChartDisplaySettingsFieldComponent,
            'Reports.chartSetupDialog.displaySettings'
        )
    ],
    ChartBlockComponent
);

export const mediaTypeBreakdownComparisonBlockType: BlockTypeModel = new BlockTypeModel(
    ReportBlockTypeEnum.MEDIA_TYPE_BREAKDOWN_COMPARISON,
    `Reports.chart.title.${ReportBlockTypeEnum.MEDIA_TYPE_BREAKDOWN_COMPARISON}`,
    'fa-regular fa-duotone fa-chart-column',
    'Chart goes here!',
    ChartDisplayElementModel,
    [
        new TextFieldModel(
            TextFieldComponent,
            'title',
            'Reports.formField.chartTitle',
            null,
            false,
            64,
            'Reports.formField.chartTitle.placeholder'
        ),
        new DateRangeFieldModel(
            DateRangeFieldComponent,
            'series',
            'Reports.formField.dateRange.label',
            ''
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.dataSource.multiSeries.label',
            'dataSource_heading'
        ),
        new SeriesPickerCompareFieldModel(
            SeriesPickerCompareFieldComponent,
            'series',
            '',
            '',
            [
                ...mentionSeriesTypes,
                ...socialSeriesTypes
            ],
            undefined,
            false,
            false,
            false,
            'dataSource_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.term.chartType',
            'chartType_heading'
        ),
        new RadioButtonsFieldModel(
            RadioButtonsFieldComponent,
            'chartSpecificType',
            '',
            false,
            [
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.COLUMN}`, ChartSpecificTypesEnum.MULTI_STACKED_COLUMN, false, '',
                    [
                        new RadioButtonOptionModel('Reports.chartSetupDialog.stacked', ChartSpecificTypesEnum.MULTI_STACKED_COLUMN),
                        new RadioButtonOptionModel('Reports.chartSetupDialog.clustered', ChartSpecificTypesEnum.COLUMN),
                    ]
                ),
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.BAR}`, ChartSpecificTypesEnum.MULTI_STACKED_BAR, false, '',
                    [
                        new RadioButtonOptionModel('Reports.chartSetupDialog.stacked', ChartSpecificTypesEnum.MULTI_STACKED_BAR),
                        new RadioButtonOptionModel('Reports.chartSetupDialog.clustered', ChartSpecificTypesEnum.BAR),
                    ]
                )
            ],
            true,
            'chartSpecificType'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.chartSetupDialog.dataDisplaySettings',
            'displaySettings_heading'
        ),
        new CheckboxesFieldModel(
            ChartDataDisplaySettingsCheckboxFieldComponent,
            'labelDisplayOptions',
            '',
            '',
            [
                new CheckboxOptionModel('Reports.formfield.displayPercentage.label', LabelDisplayOptionsEnum.percent),
                new CheckboxOptionModel('Reports.formfield.displayCount.label', LabelDisplayOptionsEnum.count)
            ],
            false,
            'displaySettings_heading',
            null,
            (displayElement: ChartDisplayElementModel) => displayElement.chartSpecificType === ChartSpecificTypesEnum.COLUMN,
            'Reports.formField.noLabelsForColumnCharts'
        ),
        new ChartDisplaySettingsFieldModel(
            'chartHeaderSettings',
            ChartDisplaySettingsFieldComponent,
            'Reports.chartSetupDialog.displaySettings'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formfield.metadata.mediaTypes',
            'colorSettings_heading'
        ),
        new MediaTypeColorPickerWrapperFieldModel(
            OptionalMediaTypeColorPickerFieldComponent,
            'styles.colorMap',
            MediaTypeCollectionTypesEnum.ALL,
            'colorSettings_heading'
        )
    ],
    ChartBlockComponent
);

export const authorsBreakdownBlockType: BlockTypeModel = new BlockTypeModel(
    ReportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME,
    `Reports.chart.title.${ReportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME}`,
    'fa-regular fa-duotone fa-chart-column',
    'Chart goes here!',
    ChartDisplayElementModel,
    [
        new TextFieldModel(
            TextFieldComponent,
            'title',
            'Reports.formField.chartTitle',
            null,
            false,
            64,
            'Reports.formField.chartTitle.placeholder'
        ),
        new DateRangeFieldModel(
            DateRangeFieldComponent,
            'series',
            'Reports.formField.dateRange.label',
            ''
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.analysis',
            'analysis_heading'
        ),
        new ChartAnalysisMetricDropdownFieldModel(
            MetricPickerComponent,
            'metric',
            '',
            '',
            [
                new DropdownOptionModel('Reports.analysis.type.volumeOfMentions', ChartMetricsEnum.volumeOfMentions),
                new DropdownOptionModel('Reports.analysis.type.audienceReach', ChartMetricsEnum.IMPRESSIONS),
                new DropdownOptionModel('Reports.analysis.type.ave', ChartMetricsEnum.ave)
            ],
            'Reports.analysis.select',
            undefined,
            'analysis_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.dataSource.singleSeries.label',
            'dataSource_heading'
        ),
        new SeriesPickerFieldModel(
            SeriesPickerFieldComponent,
            'series',
            '',
            '',
            false,
            1,
            [
                ...mentionSeriesTypes,
                ...socialSeriesTypes
            ],
            socialSeriesFilterTypes,
            undefined,
            false,
            true,
            false,
            'dataSource_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.term.chartType',
            'chartType_heading'
        ),
        new RadioButtonsFieldModel(
            RadioButtonsFieldComponent,
            'chartSpecificType',
            '',
            false,
            [
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.BAR}`, ChartSpecificTypesEnum.BAR),
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.COLUMN}`, ChartSpecificTypesEnum.COLUMN)
            ],
            true,
            'chartSpecificType'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.chartSetupDialog.dataDisplaySettings',
            'displaySettings_heading'
        ),
        new CheckboxesFieldModel(
            ChartDataDisplaySettingsCheckboxFieldComponent,
            'labelDisplayOptions',
            '',
            '',
            [
                new CheckboxOptionModel('Reports.formfield.displayPercentage.label', LabelDisplayOptionsEnum.percent),
                new CheckboxOptionModel('Reports.formfield.displayCount.label', LabelDisplayOptionsEnum.count)
            ],
            false,
            'displaySettings_heading',
            null,
            (displayElement: ChartDisplayElementModel) => displayElement.chartSpecificType === ChartSpecificTypesEnum.COLUMN,
            'Reports.formField.noLabelsForColumnCharts'
        ),
        new ChartDisplaySettingsFieldModel(
            'chartHeaderSettings',
            ChartDisplaySettingsFieldComponent,
            'Reports.chartSetupDialog.displaySettings',
            '',
            null,
            false,
            false,
            null,
            EntityType.CONTACT
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formfield.metadata.colorSettings',
        ),
        new ChartColorPickerFieldModel(
            ChartColorPickerFieldComponent,
            {
                property: 'styles.colorMap.barColor',
                key: 'seriesColor0',
                label: 'Reports.chartSetupDialog.barColor',
                description: '',
                dialogHeading: '',
                doBorder: true,
                showRecentColors: true
            },
            { colorType: 'barColors', typeProperty: 'barColor' },
        ),
    ],
    Am5ChartBlockComponent
);

export const topHashtagsBlockType: BlockTypeModel = new BlockTypeModel(
    ReportBlockTypeEnum.TOP_HASHTAGS,
    `Reports.chart.title.${ReportBlockTypeEnum.TOP_HASHTAGS}`,
    'fa-regular fa-duotone fa-chart-column',
    'Chart goes here!',
    ChartDisplayElementModel,
    [
        new TextFieldModel(
            TextFieldComponent,
            'title',
            'Reports.formField.chartTitle',
            null,
            false,
            64,
            'Reports.formField.chartTitle.placeholder'
        ),
        new DateRangeFieldModel(
            DateRangeFieldComponent,
            'series',
            'Reports.formField.dateRange.label',
            ''
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.dataSource.singleSeries.label',
            'dataSource_heading'
        ),
        new SeriesPickerFieldModel(
            SeriesPickerFieldComponent,
            'series',
            '',
            '',
            false,
            1,
            [
                ...mentionSeriesTypes,
                ...socialSeriesTypes
            ],
            socialSeriesFilterTypes,
            undefined,
            false,
            true,
            false,
            'dataSource_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.term.chartType',
            'chartType_heading'
        ),
        new RadioButtonsFieldModel(
            RadioButtonsFieldComponent,
            'chartSpecificType',
            '',
            false,
            [
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.BAR}`, ChartSpecificTypesEnum.BAR),
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.COLUMN}`, ChartSpecificTypesEnum.COLUMN)
            ],
            true,
            'chartSpecificType'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.chartSetupDialog.dataDisplaySettings',
            'displaySettings_heading'
        ),
        new CheckboxesFieldModel(
            ChartDataDisplaySettingsCheckboxFieldComponent,
            'labelDisplayOptions',
            '',
            '',
            [
                new CheckboxOptionModel('Reports.formfield.displayPercentage.label', LabelDisplayOptionsEnum.percent),
                new CheckboxOptionModel('Reports.formfield.displayCount.label', LabelDisplayOptionsEnum.count)
            ],
            false,
            'displaySettings_heading',
            null,
            (displayElement: ChartDisplayElementModel) => displayElement.chartSpecificType === ChartSpecificTypesEnum.COLUMN,
            'Reports.formField.noLabelsForColumnCharts'        ),
        new ChartDisplaySettingsFieldModel(
            'chartHeaderSettings',
            ChartDisplaySettingsFieldComponent,
            'Reports.chartSetupDialog.displaySettings'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formfield.metadata.colorSettings',
        ),
        new ChartColorPickerFieldModel(
            ChartColorPickerFieldComponent,
            {
                property: 'styles.colorMap.barColor',
                key: 'seriesColor0',
                label: 'Reports.chartSetupDialog.barColor',
                description: '',
                dialogHeading: '',
                doBorder: true,
                showRecentColors: true
            },
            { colorType: 'barColors', typeProperty: 'barColor' },
        ),
    ],
    Am5ChartBlockComponent
);

export const coverageSummaryBlockType: BlockTypeModel = new BlockTypeModel(
    ReportBlockTypeEnum.COVERAGE_SUMMARY,
    `Reports.chart.title.${ReportBlockTypeEnum.COVERAGE_SUMMARY}`,
    'fa-regular fa-duotone fa-chart-line',
    'Chart goes here!',
    CoverageSummaryChartDisplayElementModel,
    [
        new TextFieldModel(
            TextFieldComponent,
            'title',
            'Reports.formField.chartTitle',
            null,
            false,
            64,
            'Reports.formField.chartTitle.placeholder'
        ),
        new DateRangeFieldModel(
            DateRangeFieldComponent,
            'series',
            'Reports.formField.dateRange.label',
            ''
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formfield.metadata.label',
            'analysis_heading'
        ),
        new ChartAnalysisMetricDropdownFieldModel(
            MultipleMetricsPickerComponent,
            'metrics',
            '',
            '',
            [
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.volumeOfMentions}`, ChartMetricsEnum.volumeOfMentions),
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.audienceReach}`, ChartMetricsEnum.IMPRESSIONS),
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.ave}`, ChartMetricsEnum.ave),
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.positiveSentimentPercentage}`, ChartMetricsEnum.positiveSentimentPercentage),
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.neutralSentimentPercentage}`, ChartMetricsEnum.neutralSentimentPercentage),
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.negativeSentimentPercentage}`, ChartMetricsEnum.negativeSentimentPercentage),
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.ENGAGEMENTS}`, ChartMetricsEnum.ENGAGEMENTS),
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.ENGAGEMENTS_PER_POST}`, ChartMetricsEnum.ENGAGEMENTS_PER_POST),
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.ENGAGEMENT_RATE}`, ChartMetricsEnum.ENGAGEMENT_RATE),
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.APPLAUSE}`, ChartMetricsEnum.APPLAUSE),
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.CONVERSATION}`, ChartMetricsEnum.CONVERSATION),
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.AMPLIFICATION}`, ChartMetricsEnum.AMPLIFICATION),
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.VIEWS}`, ChartMetricsEnum.VIEWS),
            ],
            'Reports.analysis.select',
            {
                maxNumberOfMetrics: 3
            },
            'analysis_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.dataSource.singleSeries.label',
            'dataSource_heading'
        ),
        new SeriesPickerFieldModel(
            SeriesPickerFieldComponent,
            'series',
            '',
            '',
            false,
            1,
            [
                ...mentionSeriesTypes,
                ...socialSeriesTypes
            ],
            socialSeriesFilterTypes,
            undefined,
            false,
            false,
            false,
            'dataSource_heading'
        ),
        new ChartDisplaySettingsFieldModel(
            'chartHeaderSettings',
            ChartDisplaySettingsFieldComponent,
            'Reports.chartSetupDialog.displaySettings',
            undefined,
            undefined,
            true
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formfield.metadata.colorSettings'
        ),
        ...analysisMetricBreakdownColors(3),
    ],
    CoverageSummaryChartBlockComponent
);

export const coverageImpactTrendBlockType: BlockTypeModel = new BlockTypeModel(
    ReportBlockTypeEnum.COVERAGE_IMPACT_TREND,
    `Reports.chart.title.${ReportBlockTypeEnum.COVERAGE_IMPACT_TREND}`,
    'fa-regular fa-duotone fa-chart-line',
    'Chart goes here!',
    ChartDisplayElementModel,
    [
        new TextFieldModel(
            TextFieldComponent,
            'title',
            'Reports.formField.chartTitle',
            null,
            false,
            64,
            'Reports.formField.chartTitle.placeholder'
        ),
        new DateRangeFieldModel(
            DateRangeFieldComponent,
            'series',
            'Reports.formField.dateRange.label',
            '',
            false
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.dataSource.singleSeries.label',
            'dataSource_heading'
        ),
        new SeriesPickerFieldModel(
            SeriesPickerFieldComponent,
            'series',
            '',
            '',
            false,
            1,
            [
                ...mentionSeriesTypes,
                ...socialSeriesTypes
            ],
            socialSeriesFilterTypes,
            undefined,
            true,
            false,
            false,
            'dataSource_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'DataConnector.googleAnalytics',
            'googleAnalytics_heading'
        ),
        new ExternalDataSourcePickerFieldModel(
            ExternalDataSourcePickerFieldComponent,
            'externalDataSeries',
            'Google Analytics',
            '',
            undefined,
            false,
            'googleAnalytics_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.term.chartType',
            'chartType_heading'
        ),
        new RadioButtonsFieldModel(
            RadioButtonsFieldComponent,
            'chartSpecificType',
            '',
            false,
            [
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.LINE}`, ChartSpecificTypesEnum.LINE),
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.COLUMN}`, ChartSpecificTypesEnum.COLUMN)
            ],
            true,
            'chartSpecificType'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.chartSetupDialog.metrics',
            'metrics_heading'
        ),
        new ChartColorCheckboxesFieldModel(
            ChartColorCheckboxesFieldComponent,
            'referralTypes',
            '',
            '',
            [
                new ChartColorCheckboxOptionModel(
                    'Reports.chartSetupDialog.uniquePageViews',
                    GoogleAnalyticsReportTypesEnum.UNIQUE_PAGEVIEWS,
                    { colorType: 'generalColors', typeProperty: 'color1' },
                    false,
                    null,
                ),
                new ChartColorCheckboxOptionModel(
                    'Reports.chartSetupDialog.totalPageViews',
                    GoogleAnalyticsReportTypesEnum.TOTAL_PAGEVIEWS,
                    { colorType: 'generalColors', typeProperty: 'color1' },
                    false,
                    null
                ),
                new ChartColorCheckboxOptionModel(
                    'Reports.chartSetupDialog.sessions',
                    GoogleAnalyticsReportTypesEnum.SESSIONS,
                    { colorType: 'generalColors', typeProperty: 'color2' },
                    false,
                    null,
                ),
                new ChartColorCheckboxOptionModel(
                    'Reports.chartSetupDialog.users',
                    GoogleAnalyticsReportTypesEnum.USERS,
                    { colorType: 'generalColors', typeProperty: 'color3' },
                    false,
                    null,
                ),
            ],
            false,
            '',
            'metrics_heading'
        ),
        new ChartDisplaySettingsFieldModel(
            'chartHeaderSettings',
            ChartDisplaySettingsFieldComponent,
            'Reports.chartSetupDialog.displaySettings'
        ),
        new PREventsFieldModel(
            PREventsFieldComponent,
            'prevents',
            'Reports.chartSetupDialog.prEvents'
        )
    ],
    Am5ChartBlockComponent
);

export const referralTrendBlockType: BlockTypeModel = new BlockTypeModel(
    ReportBlockTypeEnum.REFERRAL_TREND,
    `Reports.chart.title.${ReportBlockTypeEnum.REFERRAL_TREND}`,
    'fa-regular fa-duotone fa-chart-line',
    'Chart goes here!',
    ChartDisplayElementModel,
    [
        new TextFieldModel(
            TextFieldComponent,
            'title',
            'Reports.formField.chartTitle',
            null,
            false,
            64,
            'Reports.formField.chartTitle.placeholder'
        ),
        new ExternalDataSourceDateRangeFieldModel(
            ExternalDataSourceDateRangeFieldComponent,
            'series',
            'Reports.formField.dateRange.label'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.dataSource.singleSeries.label',
            'dataSource_heading'
        ),
        new ExternalDataSourcePickerFieldModel(
            ExternalDataSourcePickerFieldComponent,
            'externalDataSeries',
            'Google Analytics',
            '',
            undefined,
            false,
            'dataSource_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.term.chartType',
            'chartType_heading'
        ),
        new RadioButtonsFieldModel(
            RadioButtonsFieldComponent,
            'chartSpecificType',
            '',
            false,
            [
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.LINE}`, ChartSpecificTypesEnum.MULTI_LINE),
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.COLUMN}`, ChartSpecificTypesEnum.COLUMN)
            ],
            true,
            'chartSpecificType'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.chartSetupDialog.dataDisplaySettings',
            'displaySettings_heading'
        ),
        new ChartColorCheckboxesFieldModel(
            ChartColorCheckboxesFieldComponent,
            'referralTypes',
            '',
            '',
            [
                new ChartColorCheckboxOptionModel(
                    `Reports.googleAnalyticsCharts.${GoogleAnalyticsReportTypesEnum.TOTAL_REFERRALS}`,
                    GoogleAnalyticsReportTypesEnum.TOTAL_REFERRALS,
                    { colorType: 'generalColors', typeProperty: 'color1' },
                    false,
                    'Reports.chartSetupDialog.allReferralsTooltip',
                ),
                new ChartColorCheckboxOptionModel(
                    `Reports.googleAnalyticsCharts.${GoogleAnalyticsReportTypesEnum.WEB_REFERRALS}`,
                    GoogleAnalyticsReportTypesEnum.WEB_REFERRALS,
                    { colorType: 'generalColors', typeProperty: 'color2' },
                    false,
                    'Reports.chartSetupDialog.webReferralsTooltip',
                ),
                new ChartColorCheckboxOptionModel(
                    `Reports.googleAnalyticsCharts.${GoogleAnalyticsReportTypesEnum.SOCIAL_REFERRALS}`,
                    GoogleAnalyticsReportTypesEnum.SOCIAL_REFERRALS,
                    { colorType: 'generalColors', typeProperty: 'color3' },
                    false,
                    'Reports.chartSetupDialog.socialReferralsTooltip',
                ),
                new ChartColorCheckboxOptionModel(
                    `Reports.googleAnalyticsCharts.${GoogleAnalyticsReportTypesEnum.EMAIL_REFERRALS}`,
                    GoogleAnalyticsReportTypesEnum.EMAIL_REFERRALS,
                    { colorType: 'generalColors', typeProperty: 'color4' },
                    false,
                    'Reports.chartSetupDialog.emailReferralsTooltip',
                ),
            ],
            false,
            '',
            'displaySettings_heading'
        ),
        new ChartDisplaySettingsFieldModel(
            'chartHeaderSettings',
            ChartDisplaySettingsFieldComponent,
            'Reports.chartSetupDialog.displaySettings'
        ),
        new PREventsFieldModel(
            PREventsFieldComponent,
            'prevents',
            'Reports.chartSetupDialog.prEvents'
        )
    ],
    ChartBlockComponent
);

export const prominenceOverTimeBlockType: BlockTypeModel = new BlockTypeModel(
    ReportBlockTypeEnum.PROMINENCE_OVER_TIME,
    `Reports.chart.title.${ReportBlockTypeEnum.PROMINENCE_OVER_TIME}`,
    'fa-regular fa-duotone fa-chart-line',
    'Chart goes here!',
    ChartDisplayElementModel,
    [
        new TextFieldModel(
            TextFieldComponent,
            'title',
            'Reports.formField.chartTitle',
            null,
            false,
            64,
            'Reports.formField.chartTitle.placeholder'
        ),
        new DateRangeFieldModel(
            DateRangeFieldComponent,
            'series',
            'Reports.formField.dateRange.label',
            ''
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.dataSource.singleSeries.label',
            'dataSource_heading'
        ),
        new SeriesPickerFieldModel(
            SeriesPickerFieldComponent,
            'series',
            '',
            '',
            false,
            1,
            [
                SeriesTypeEnum.folder,
                SeriesTypeEnum.tag,
                SeriesTypeEnum.tagGroup
            ],
            undefined,
            undefined,
            true,
            false,
            false,
            'dataSource_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.prominence.subject',
            'prominenceSubjects_heading',
            undefined,
            {
                icon: 'fa-regular fa-duotone fa-gear',
                tooltip: 'Reports.prominence.subject.manage',
                panel: ProminenceTakeOverPanelComponent
            }
        ),
        new ProminenceGroupPickerModel(
            ProminenceGroupPickerComponent,
            'prominenceSubjects_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.term.chartType',
            'chartType_heading'
        ),
        new RadioButtonsFieldModel(
            RadioButtonsFieldComponent,
            'chartSpecificType',
            '',
            false,
            [
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.LINE}`, ChartSpecificTypesEnum.FILLED_LINE),
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.COLUMN}`, ChartSpecificTypesEnum.COLUMN)
            ],
            true,
            'chartSpecificType'
        ),
        new ChartDisplaySettingsFieldModel(
            'chartHeaderSettings',
            ChartDisplaySettingsFieldComponent,
            'Reports.chartSetupDialog.displaySettings'
        )
    ],
    ChartBlockComponent
);

export const prominenceByReachBlockType: BlockTypeModel = new BlockTypeModel(
    ReportBlockTypeEnum.PROMINENCE_BY_REACH,
    `Reports.chart.title.${ReportBlockTypeEnum.PROMINENCE_BY_REACH}`,
    'fa-regular fa-duotone fa-table-cells-large',
    'Chart goes here!',
    ChartDisplayElementModel,
    [
        new TextFieldModel(
            TextFieldComponent,
            'title',
            'Reports.formField.chartTitle',
            null,
            false,
            64,
            'Reports.formField.chartTitle.placeholder'
        ),
        new DateRangeFieldModel(
            DateRangeFieldComponent,
            'series',
            'Reports.formField.dateRange.label',
            ''
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.dataSource.singleSeries.label',
            'dataSource_heading'
        ),
        new SeriesPickerFieldModel(
            SeriesPickerFieldComponent,
            'series',
            '',
            '',
            false,
            1,
            [
                SeriesTypeEnum.folder,
                SeriesTypeEnum.tag,
                SeriesTypeEnum.tagGroup
            ],
            undefined,
            undefined,
            true,
            false,
            false,
            'dataSource_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.prominence.subject',
            'prominenceSubjects_heading',
            undefined,
            {
                icon: 'fa-regular fa-duotone fa-gear',
                tooltip: 'Reports.prominence.subject.manage',
                panel: ProminenceTakeOverPanelComponent
            }
        ),
        new ProminenceGroupPickerModel(ProminenceGroupPickerComponent, 'prominenceSubjects_heading'),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.chartSetupDialog.dataDisplaySettings',
            'displaySettings_heading'
        ),
        new CheckboxesFieldModel(
            CheckboxesFieldComponent,
            'labelDisplayOptions',
            '',
            '',
            [
                new CheckboxOptionModel('Reports.formfield.displayPercentage.label', LabelDisplayOptionsEnum.percent),
                new CheckboxOptionModel('Reports.formfield.displayCount.label', LabelDisplayOptionsEnum.count)
            ],
            false,
            'displaySettings_heading'
        ),
        new ChartDisplaySettingsFieldModel(
            'chartHeaderSettings',
            ChartDisplaySettingsFieldComponent,
            'Reports.chartSetupDialog.displaySettings'
        )
    ],
    ChartBlockComponent
);

export const topSocialReferrersBlockType: BlockTypeModel = new BlockTypeModel(
    ReportBlockTypeEnum.TOP_SOCIAL_REFERRERS,
    `Reports.chart.title.${ReportBlockTypeEnum.TOP_SOCIAL_REFERRERS}`,
    'fa-regular fa-duotone fa-chart-column',
    'Chart goes here!',
    ChartDisplayElementModel,
    [
        new TextFieldModel(
            TextFieldComponent,
            'title',
            'Reports.formField.chartTitle',
            null,
            false,
            64,
            'Reports.formField.chartTitle.placeholder'
        ),
        new DateRangeFieldModel(
            DateRangeFieldComponent,
            'series',
            'Reports.formField.dateRange.label',
            null
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.dataSource.singleSeries.label',
            'dataSource_heading'
        ),
        new ExternalDataSourcePickerFieldModel(
            ExternalDataSourcePickerFieldComponent,
            'externalDataSeries',
            'Google Analytics',
            '',
            undefined,
            false,
            'dataSource_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.chartSetupDialog.metrics',
            'metrics_heading'
        ),
        new RadioButtonsFieldModel(
            RadioButtonsFieldComponent,
            'metric',
            '',
            false,
            [
                new RadioButtonOptionModel('Reports.chartSetupDialog.sessions', ExternalChartMetricsEnum.sessions),
                new RadioButtonOptionModel('Reports.chartSetupDialog.users', ExternalChartMetricsEnum.users)
            ],
            false,
            'metrics_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.term.chartType',
            'chartType_heading'
        ),
        new RadioButtonsFieldModel(
            RadioButtonsFieldComponent,
            'chartSpecificType',
            '',
            false,
            [
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.BAR}`, ChartSpecificTypesEnum.BAR),
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.COLUMN}`, ChartSpecificTypesEnum.COLUMN)
            ],
            true,
            'chartSpecificType'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.chartSetupDialog.dataDisplaySettings',
            'displaySettings_heading'
        ),
        new CheckboxesFieldModel(
            CheckboxesFieldComponent,
            'labelDisplayOptions',
            '',
            '',
            [
                new CheckboxOptionModel('Reports.formfield.displayPercentage.label', LabelDisplayOptionsEnum.percent),
                new CheckboxOptionModel('Reports.formfield.displayCount.label', LabelDisplayOptionsEnum.count)
            ],
            false,
            'displaySettings_heading'
        ),
        new ChartDisplaySettingsFieldModel(
            'chartHeaderSettings',
            ChartDisplaySettingsFieldComponent,
            'Reports.chartSetupDialog.displaySettings'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formfield.metadata.colorSettings'
        ),
        new ChartColorPickerFieldModel(
            ChartColorPickerFieldComponent,
            {
                property: 'styles.colorMap.barColor',
                key: 'barColor',
                label: 'Reports.chartSetupDialog.barColor',
                description: '',
                dialogHeading: '',
                doBorder: true,
                showRecentColors: true
            },
            { colorType: 'barColors', typeProperty: 'barColor' },
        ),
    ],
    Am5ChartBlockComponent
);

export const topReferralSourcesBlockType: BlockTypeModel = new BlockTypeModel(
    ReportBlockTypeEnum.TOP_REFERRAL_SOURCES,
    `Reports.chart.title.${ReportBlockTypeEnum.TOP_REFERRAL_SOURCES}`,
    'fa-regular fa-duotone fa-chart-column',
    'Chart goes here!',
    ChartDisplayElementModel,
    [
        new TextFieldModel(
            TextFieldComponent,
            'title',
            'Reports.formField.chartTitle',
            null,
            false,
            64,
            'Reports.formField.chartTitle.placeholder'
        ),
        new DateRangeFieldModel(
            DateRangeFieldComponent,
            'series',
            'Reports.formField.dateRange.label',
            null
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.dataSource.singleSeries.label',
            'dataSource_heading'
        ),
        new ExternalDataSourcePickerFieldModel(
            ExternalDataSourcePickerFieldComponent,
            'externalDataSeries',
            'Google Analytics',
            '',
            undefined,
            false,
            'dataSource_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.chartSetupDialog.metrics',
            'metrics_heading'
        ),
        new RadioButtonsFieldModel(
            RadioButtonsFieldComponent,
            'metric',
            '',
            true,
            [
                new RadioButtonOptionModel('Reports.chartSetupDialog.sessions', ExternalChartMetricsEnum.sessions, false, '',
                    [
                        new ChartColorRadioOptionModel(
                            'Reports.chartSetupDialog.' + ExternalChartMetricsEnum.sessions,
                            ExternalChartMetricsEnum.sessions,
                            false,
                            '',
                            null,
                            (displayElement: ChartDisplayElementModel) => true,
                            true,
                            [
                                new ChartColorPickerFieldModel(
                                    ChartColorPickerFieldComponent,
                                    {
                                        property: `styles.colorMap.${ExternalChartMetricsEnum.sessions}`,
                                        key: ExternalChartMetricsEnum.sessions,
                                        label: '',
                                        description: '',
                                        dialogHeading: '',
                                        doBorder: true,
                                        showRecentColors: true
                                    },
                                    { colorType: 'barColors', typeProperty: 'barColor' },
                                )
                            ]
                        ),
                        new ChartColorRadioOptionModel(
                            'Reports.chartSetupDialog.sessions.newAndReturning',
                            ExternalChartMetricsEnum.sessionsNewReturning,
                            false,
                            '',
                            null,
                            (displayElement: ChartDisplayElementModel) => true,
                            true,
                            [
                                new ChartColorPickerFieldModel(
                                    ChartColorPickerFieldComponent,
                                    {
                                        property: `styles.colorMap.${ExternalChartMetricsEnum.sessionsNew}`,
                                        key: ExternalChartMetricsEnum.sessionsNew,
                                        label: `Reports.chartSetupDialog.${ExternalChartMetricsEnum.sessionsNew}`,
                                        description: '',
                                        dialogHeading: '',
                                        doBorder: true,
                                        showRecentColors: true
                                    },
                                    { colorType: 'generalColors', typeProperty: 'color1' },
                                ),
                                new ChartColorPickerFieldModel(
                                    ChartColorPickerFieldComponent,
                                    {
                                        property: `styles.colorMap.${ExternalChartMetricsEnum.sessionsReturning}`,
                                        key: ExternalChartMetricsEnum.sessionsReturning,
                                        label: `Reports.chartSetupDialog.${ExternalChartMetricsEnum.sessionsReturning}`,
                                        description: '',
                                        dialogHeading: '',
                                        doBorder: true,
                                        showRecentColors: true
                                    },
                                    { colorType: 'generalColors', typeProperty: 'color2' },
                                )
                            ]
                        )
                    ]
                ),
                new RadioButtonOptionModel('Reports.chartSetupDialog.users', ExternalChartMetricsEnum.users, false, '',
                    [
                        new ChartColorRadioOptionModel(
                            `Reports.chartSetupDialog.${ExternalChartMetricsEnum.users}`,
                            ExternalChartMetricsEnum.users,
                            false,
                            '',
                            null,
                            (displayElement: ChartDisplayElementModel) => true,
                            true,
                            [
                                new ChartColorPickerFieldModel(
                                    ChartColorPickerFieldComponent,
                                    {
                                        property: `styles.colorMap.${ExternalChartMetricsEnum.users}`,
                                        key: ExternalChartMetricsEnum.users,
                                        label: '',
                                        description: '',
                                        dialogHeading: '',
                                        doBorder: true,
                                        showRecentColors: true
                                    },
                                    { colorType: 'barColors', typeProperty: 'barColor' },
                                )
                            ]
                        ),
                        new ChartColorRadioOptionModel(
                            'Reports.chartSetupDialog.users.newAndReturning',
                            ExternalChartMetricsEnum.usersNewReturning,
                            false,
                            '',
                            null,
                            (displayElement: ChartDisplayElementModel) => true,
                            true,
                            [
                                new ChartColorPickerFieldModel(
                                    ChartColorPickerFieldComponent,
                                    {
                                        property: `styles.colorMap.${ExternalChartMetricsEnum.usersNew}`,
                                        key: ExternalChartMetricsEnum.usersNew,
                                        label: `Reports.chartSetupDialog.${ExternalChartMetricsEnum.usersNew}`,
                                        description: '',
                                        dialogHeading: '',
                                        doBorder: true,
                                        showRecentColors: true
                                    },
                                    { colorType: 'generalColors', typeProperty: 'color1' },
                                ),
                                new ChartColorPickerFieldModel(
                                    ChartColorPickerFieldComponent,
                                    {
                                        property: `styles.colorMap.${ExternalChartMetricsEnum.usersReturning}`,
                                        key: ExternalChartMetricsEnum.usersReturning,
                                        label: `Reports.chartSetupDialog.${ExternalChartMetricsEnum.usersReturning}`,
                                        description: '',
                                        dialogHeading: '',
                                        doBorder: true,
                                        showRecentColors: true
                                    },
                                    { colorType: 'generalColors', typeProperty: 'color2' },
                                )
                            ]
                        )
                    ]
                )
            ],
            false,
            'metrics_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.term.chartType',
            'chartType_heading'
        ),
        new RadioButtonsFieldModel(
            RadioButtonsFieldComponent,
            'chartSpecificType',
            '',
            false,
            [
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.BAR}`, ChartSpecificTypesEnum.BAR),
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.COLUMN}`, ChartSpecificTypesEnum.COLUMN)
            ],
            true,
            'chartSpecificType'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.chartSetupDialog.dataDisplaySettings',
            'displaySettings_heading'
        ),
        new CheckboxesFieldModel(
            ChartDataDisplaySettingsCheckboxFieldComponent,
            'labelDisplayOptions',
            '',
            '',
            [
                new CheckboxOptionModel('Reports.formfield.displayPercentage.label', LabelDisplayOptionsEnum.percent),
                new CheckboxOptionModel('Reports.formfield.displayCount.label', LabelDisplayOptionsEnum.count)
            ],
            false,
            'displaySettings_heading',
            null,
            (displayElement: ChartDisplayElementModel) => displayElement.chartSpecificType === ChartSpecificTypesEnum.COLUMN,
            'Reports.formField.noLabelsForColumnCharts'
        ),
        new ChartDisplaySettingsFieldModel(
            'chartHeaderSettings',
            ChartDisplaySettingsFieldComponent,
            'Reports.chartSetupDialog.displaySettings'
        )
    ],
    ChartBlockComponent
);

export const socialCoverageByNetwork: BlockTypeModel = new BlockTypeModel(
    ReportBlockTypeEnum.SOCIAL_COVERAGE_BY_NETWORK,
    `Reports.chart.title.${ReportBlockTypeEnum.SOCIAL_COVERAGE_BY_NETWORK}`,
    'fa-regular fa-duotone fa-chart-column',
    'Chart goes here!',
    ChartDisplayElementModel,
    [
        new TextFieldModel(
            TextFieldComponent,
            'title',
            'Reports.formField.chartTitle',
            null,
            false,
            64,
            'Reports.formField.chartTitle.placeholder'
        ),
        new DateRangeFieldModel(
            DateRangeFieldComponent,
            'series',
            'Reports.formField.dateRange.label',
            ''
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.analysis',
            'analysis_heading'
        ),
        new ChartAnalysisMetricDropdownFieldModel(
            MetricPickerComponent,
            'metric',
            '',
            '',
            [
                new DropdownOptionModel('Reports.analysis.type.posts', ChartMetricsEnum.volumeOfMentions),
                new DropdownOptionModel('Reports.analysis.type.impressions', ChartMetricsEnum.IMPRESSIONS),
                new DropdownOptionModel('Reports.analysis.type.engagements', ChartMetricsEnum.ENGAGEMENTS),
                new DropdownOptionModel('Reports.analysis.type.engagementRate', ChartMetricsEnum.ENGAGEMENT_RATE),
                new DropdownOptionModel('Reports.analysis.type.applause', ChartMetricsEnum.LIKES),
                new DropdownOptionModel('Reports.analysis.type.converstation', ChartMetricsEnum.CONVERSATION),
                new DropdownOptionModel('Reports.analysis.type.amplification', ChartMetricsEnum.SHARES),
                new DropdownOptionModel('Reports.analysis.type.views', ChartMetricsEnum.VIEWS),
            ],
            'Reports.analysis.select',
            undefined,
            'analysis_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.dataSource.singleSeries.label',
            'dataSource_heading'
        ),
        new SeriesPickerFieldModel(
            SeriesPickerFieldComponent,
            'series',
            '',
            '',
            false,
            1,
            [
                ...mentionSeriesTypes,
                ...socialSeriesTypes
            ],
            undefined,
            undefined,
            false,
            true,
            false,
            'dataSource_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.chartSetupDialog.networkSelection',
            'network_heading'
        ),
        new CheckboxesFieldModel(
            ChartNetworkCheckboxFieldComponent,
            'networkSelection',
            '',
            '',
            [],
            false,
            'network_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.term.chartType',
            'chartType_heading'
        ),
        new RadioButtonsFieldModel(
            RadioButtonsFieldComponent,
            'chartSpecificType',
            '',
            false,
            [
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.PIE}`, ChartSpecificTypesEnum.PIE),
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.COLUMN}`, ChartSpecificTypesEnum.MULTI_STACKED_COLUMN, false, '',
                    [
                        new RadioButtonOptionModel('Reports.chartSetupDialog.stacked', ChartSpecificTypesEnum.MULTI_STACKED_COLUMN),
                        new RadioButtonOptionModel('Reports.chartSetupDialog.clustered', ChartSpecificTypesEnum.COLUMN),
                    ]
                ),
                new RadioButtonOptionModel(`Reports.chartSpecificType.${ChartSpecificTypesEnum.BAR}`, ChartSpecificTypesEnum.MULTI_STACKED_BAR, false, '',
                    [
                        new RadioButtonOptionModel('Reports.chartSetupDialog.stacked', ChartSpecificTypesEnum.MULTI_STACKED_BAR),
                        new RadioButtonOptionModel('Reports.chartSetupDialog.clustered', ChartSpecificTypesEnum.BAR),
                    ]
                )
            ],
            true,
            'chartSpecificType'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.chartSetupDialog.dataDisplaySettings',
            'displaySettings_heading'
        ),
        new CheckboxesFieldModel(
            ChartDataDisplaySettingsCheckboxFieldComponent,
            'labelDisplayOptions',
            '',
            '',
            [
                new CheckboxOptionModel('Reports.formfield.displayPercentage.label', LabelDisplayOptionsEnum.percent),
                new CheckboxOptionModel('Reports.formfield.displayCount.label', LabelDisplayOptionsEnum.count)
            ],
            false,
            'displaySettings_heading',
            null,
            (displayElement: ChartDisplayElementModel) => displayElement.chartSpecificType === ChartSpecificTypesEnum.COLUMN,
            'Reports.formField.noLabelsForColumnCharts'
        ),
        new ChartDisplaySettingsFieldModel(
            'chartHeaderSettings',
            ChartDisplaySettingsFieldComponent,
            'Reports.chartSetupDialog.displaySettings',
            undefined,
            undefined,
            true,
            true,
            (displayElement: ChartDisplayElementModel) => displayElement.chartSpecificType === ChartSpecificTypesEnum.BAR
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formfield.metadata.colorSettings',
            'colorSettings_heading'
        ),
        new MediaTypeColorPickerWrapperFieldModel(
            MediaTypeColorPickerWrapperFieldComponent,
            'styles.colorMap',
            MediaTypeCollectionTypesEnum.CORE_SOCIAL_MEDIA_TYPE_ONLY,
            'colorSettings_heading'
        ),
        new RadioButtonsFieldModel(
            RadioButtonsFieldComponent,
            'styles.previousPeriodBarColorType',
            'Reports.chartSetupDialog.previousBarColor',
            true,
            [
                new ChartColorRadioOptionModel(
                    'Reports.chartSetupDialog.selectColor',
                    PreviousPeriodBarColorsEnum.CUSTOM,
                    false,
                    '',
                    [
                        new ChartColorRadioOptionModel(
                            '',
                            PreviousPeriodBarColorsEnum.CUSTOM,
                            false,
                            '',
                            [],
                            (displayElement: ChartDisplayElementModel) => true,
                            false,
                            [
                                new ChartColorPickerFieldModel(
                                    ChartColorPickerFieldComponent,
                                    {
                                        property: 'styles.colorMap.previousPeriodBarColor',
                                        key: 'previousPeriodBarColor',
                                        label: '',
                                        description: '',
                                        dialogHeading: '',
                                        doBorder: true,
                                        showRecentColors: true
                                    },
                                    { colorType: 'barColors', typeProperty: 'previousBarColor' },
                                    'previousBar_selectColor',
                                    (displayElement: DisplayElementModel) => true,
                                )
                            ]
                        )
                    ],
                    (displayElement: ChartDisplayElementModel) => true,
                    false
                ),
                new RadioButtonOptionModel(
                    'Reports.chartSetupDialog.useBarColor',
                    PreviousPeriodBarColorsEnum.USE_BAR
                )
            ],
            false,
            'previousBarColor_radioButtons',
            (displayElement: DisplayElementModel) => {
                return (<ChartDisplayElementModel>displayElement).chartHeaderSettings.previousPeriod
                    && ((<ChartDisplayElementModel>displayElement).chartSpecificType === ChartSpecificTypesEnum.BAR
                    || (<ChartDisplayElementModel>displayElement).chartSpecificType === ChartSpecificTypesEnum.COLUMN);
            },
            'agpr-radioButtonContainer-heading--normal'
        ),
        new ChartColorPickerFieldModel(
            ChartColorPickerFieldComponent,
            {
                property: 'styles.colorMap.uptrendColor',
                key: 'uptrendColor',
                label: 'Reports.chartSetupDialog.uptrend',
                description: '',
                dialogHeading: '',
                doBorder: true,
                showRecentColors: true
            },
            { colorType: 'otherColors', typeProperty: 'uptrendColor' },
            'uptrendColorPicker',
            (displayElement: ChartDisplayElementModel) => {
                return !!displayElement.chartHeaderSettings?.trendIndicators;
            }
        ),
        new ChartColorPickerFieldModel(
            ChartColorPickerFieldComponent,
            {
                property: 'styles.colorMap.downtrendColor',
                key: 'downtrendColor',
                label: 'Reports.chartSetupDialog.downtrend',
                description: '',
                dialogHeading: '',
                doBorder: true,
                showRecentColors: true
            },
            { colorType: 'otherColors', typeProperty: 'downtrendColor' },
            'downtrendColorPicker',
            (displayElement: ChartDisplayElementModel) => {
                return !!displayElement.chartHeaderSettings?.trendIndicators;
            }
        )
    ],
    ChartBlockComponent
);

export const topTermsBlockType: BlockTypeModel = new BlockTypeModel(
    ReportBlockTypeEnum.TOP_TERMS,
    `Reports.chart.title.${ReportBlockTypeEnum.TOP_TERMS}`,
    'fa-kit-duotone fa-agpr-cloud-list',
    'Chart goes here!',
    ChartDisplayElementModel,
    [
        new TextFieldModel(
            TextFieldComponent,
            'title',
            'Reports.formField.chartTitle',
            null,
            false,
            64,
            'Reports.formField.chartTitle.placeholder'
        ),
        new DateRangeFieldModel(
            DateRangeFieldComponent,
            'series',
            'Reports.formField.dateRange.label',
            ''
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.term.type',
            'termType_heading'
        ),
        new RadioButtonsFieldModel(
            TermTypesRadioButtonsFieldComponent,
            'termType',
            '',
            false,
            [
                new RadioButtonOptionModel('Reports.term.type.hashtags', TermTypesEnum.HASHTAGS),
                new RadioButtonOptionModel('Reports.term.type.handles', TermTypesEnum.HANDLES),
                new RadioButtonOptionModel('Reports.term.type.words', TermTypesEnum.WORDS),
            ],
            false,
            'termType_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.analysis',
            'analysis_heading'
        ),
        new ChartAnalysisMetricDropdownFieldModel(
            MetricPickerComponent,
            'metric',
            '',
            '',
            [
                new DropdownOptionModel('Reports.analysis.type.volume', ChartMetricsEnum.VOLUME),
                new DropdownOptionModel('Reports.analysis.type.ave', ChartMetricsEnum.ave),
                new DropdownOptionModel(`Reports.analysis.type.${SocialSeriesMetricsEnum.IMPRESSIONS}`, ChartMetricsEnum.IMPRESSIONS),
                new DropdownOptionModel(`Reports.analysis.type.${SocialSeriesMetricsEnum.ENGAGEMENTS}`, ChartMetricsEnum.ENGAGEMENTS),
                new DropdownOptionModel(`Reports.analysis.type.${SocialSeriesMetricsEnum.APPLAUSE}`, ChartMetricsEnum.APPLAUSE),
                new DropdownOptionModel(`Reports.analysis.type.${SocialSeriesMetricsEnum.CONVERSATION}`, ChartMetricsEnum.CONVERSATION),
                new DropdownOptionModel(`Reports.analysis.type.${SocialSeriesMetricsEnum.AMPLIFICATION}`, ChartMetricsEnum.AMPLIFICATION),
                new DropdownOptionModel(`Reports.analysis.type.${SocialSeriesMetricsEnum.VIEWS}`, ChartMetricsEnum.VIEWS),
            ],
            'Reports.analysis.select',
            undefined,
            'analysis_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.dataSource.singleSeries.label',
            'dataSource_heading'
        ),
        new SeriesPickerFieldModel(
            SeriesPickerFieldComponent,
            'series',
            '',
            '',
            false,
            1,
            [
                ...mentionSeriesTypes,
                ...socialSeriesTypes
            ],
            undefined,
            undefined,
            false,
            true,
            false,
            'dataSource_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.term.chartType',
            'chartType_heading'
        ),
        new RadioButtonsFieldModel(
            TermTypesRadioButtonsFieldComponent,
            'chartSpecificType',
            '',
            false,
            [
                new RadioButtonOptionModel('Reports.term.chartType.cardList', ChartSpecificTypesEnum.CARD_LIST),
                new RadioButtonOptionModel('Reports.term.chartType.wordCloud', ChartSpecificTypesEnum.WORD_CLOUD),
            ],
            true,
            'chartType_heading'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.chartSetupDialog.displaySettings',
            ''
        ),
        new DropdownFieldModel(
            DropdownFieldComponent,
            'numOfItems',
            'Reports.term.numToDisplay',
            null,
            [
                {label: '1' , value: 1},
                {label: '2' , value: 2},
                {label: '3' , value: 3},
                {label: '4' , value: 4},
                {label: '5' , value: 5},
                {label: '6' , value: 6},
                {label: '7' , value: 7},
                {label: '8' , value: 8},
                {label: '9' , value: 9},
                {label: '10' , value: 10},
            ]
        ),
        new ChartDisplaySettingsFieldModel(
            'chartHeaderSettings',
            ChartDisplaySettingsFieldComponent,
            ''
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formfield.metadata.colorSettings',
        ),
        new ChartColorPickerFieldModel(
            ChartColorPickerFieldComponent,
            {
                property: 'styles.colorMap.barColor',
                key: 'seriesColor0',
                label: '',
                description: '',
                dialogHeading: '',
                doBorder: true,
                showRecentColors: true
            },
            { colorType: 'barColors', typeProperty: 'barColor' },
        )
    ],
    TopTermChartBlockComponent
);

const topMentionsMetadataColors: ChartColorPickerFieldModel[] = Array.from({length: 2}, (_, i) => i + 1).map(
    n => {
        return new ChartColorPickerFieldModel(
            ChartColorPickerFieldComponent,
            {
                property: 'styles.colorMap.metadataType' + n,
                key: 'metadata' + n,
                label: 'Reports.formField.metadataTypes.' + n,
                description: '',
                dialogHeading: '',
                doBorder: true,
                showRecentColors: true
            },
            { colorType: 'generalColors', typeProperty: ('color' + n) as keyof UserAppPreferenceChartColors['generalColors'] },
        );
    }
);

export const topMentionsBlockType: BlockTypeModel = new BlockTypeModel(
    ReportBlockTypeEnum.TOP_MENTIONS,
    `Reports.chart.title.${ReportBlockTypeEnum.TOP_MENTIONS}`,
    'fa-kit-duotone fa-agpr-posts',
    'Chart goes here!',
    ChartDisplayElementModel,
    [
        new TextFieldModel(
            TextFieldComponent,
            'title',
            'Reports.formField.chartTitle',
            null,
            false,
            64,
            'Reports.formField.chartTitle.placeholder'
        ),
        new DateRangeFieldModel(
            DateRangeFieldComponent,
            'series',
            'Reports.formField.dateRange.label',
            '',
            true,
            (displayElement: ChartDisplayElementModel) => displayElement.topMentionsSortField !== SearchCriteriaSortFieldEnum.custom
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.analysis',
            'analysis_heading'
        ),
        new DropdownFieldModel(
            TopMentionsSortFieldComponent,
            'topMentionsSortField',
            'Reports.topMentions.sortField.dropdownLabel',
            '',
            [
                new DropdownOptionModel(`Reports.topMentions.sortField.${SearchCriteriaSortFieldEnum.audience_reach}`, SearchCriteriaSortFieldEnum.audience_reach),
                new DropdownOptionModel(`Reports.topMentions.sortField.${SearchCriteriaSortFieldEnum.ave}`, SearchCriteriaSortFieldEnum.ave),
                new DropdownOptionModel(`Reports.topMentions.sortField.${SearchCriteriaSortFieldEnum.domainAuthority}`, SearchCriteriaSortFieldEnum.domainAuthority),
                new DropdownOptionModel(`Reports.topMentions.sortField.${SearchCriteriaSortFieldEnum.relevancy}`, SearchCriteriaSortFieldEnum.relevancy),
                new DropdownOptionModel(`Reports.topMentions.sortField.${SearchCriteriaSortFieldEnum.custom}`, SearchCriteriaSortFieldEnum.custom)
            ]
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.dataSource.singleSeries.label',
            'topMentions_dataSource_heading',
            (displayElement: ChartDisplayElementModel) => displayElement.topMentionsSortField !== SearchCriteriaSortFieldEnum.custom
        ),
        new SeriesPickerFieldModel(
            SeriesPickerFieldComponent,
            'series',
            '',
            '',
            false,
            1,
            [
                ...mentionSeriesTypes,
                ...socialSeriesTypes
            ],
            undefined,
            undefined,
            false,
            true,
            false,
            'topMentions_dataSource',
            (displayElement: ChartDisplayElementModel) => displayElement.topMentionsSortField !== SearchCriteriaSortFieldEnum.custom
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.topMentions.metadata.heading',
            ''
        ),
        new TopMentionsMetadataFieldModel(
            'topMentionsMetadata',
            TopMentionsMetadataFieldComponent,
            'topMentions_metadata'
        ),
        new TopCuratedMentionsFieldModel(
            'topCuratedMentions',
            TopCuratedMentionsFieldComponent,
            'topMentions_topCuratedMentions'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.chartSetupDialog.displaySettings',
            ''
        ),
        new DropdownFieldModel(
            DropdownFieldComponent,
            'numOfItems',
            'Reports.topMentions.numToDisplay',
            null,
            [
                {label: '1' , value: 1},
                {label: '2' , value: 2},
                {label: '3' , value: 3},
                {label: '4' , value: 4},
                {label: '5' , value: 5},
                {label: '6' , value: 6},
                {label: '7' , value: 7},
                {label: '8' , value: 8},
                {label: '9' , value: 9},
                {label: '10' , value: 10},
            ]
        ),
        new ChartDisplaySettingsFieldModel(
            'chartHeaderSettings',
            ChartDisplaySettingsFieldComponent,
            ''
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formfield.metadata.colorSettings',
        ),
        ...topMentionsMetadataColors
    ],
    TopMentionsChartBlockComponent
);

export const topPostsBlockType: BlockTypeModel = new BlockTypeModel(
    ReportBlockTypeEnum.TOP_POSTS,
    `Reports.chart.title.${ReportBlockTypeEnum.TOP_POSTS}`,
    'fa-kit-duotone fa-agpr-posts',
    'Chart goes here!',
    ChartDisplayElementModel,
    [
        new TextFieldModel(
            TextFieldComponent,
            'title',
            'Reports.formField.chartTitle',
            null,
            false,
            64,
            'Reports.formField.chartTitle.placeholder'
        ),
        new DateRangeFieldModel(
            DateRangeFieldComponent,
            'series',
            'Reports.formField.dateRange.label',
            '',
            true,
            (displayElement: ChartDisplayElementModel) => displayElement.topMentionsSortField !== SearchCriteriaSortFieldEnum.custom
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.analysis',
            'analysis_heading'
        ),
        new DropdownFieldModel(
            TopMentionsSortFieldComponent,
            'topMentionsSortField',
            'Reports.topMentions.sortField.dropdownLabel',
            '',
            [
                new DropdownOptionModel(`Reports.topMentions.sortField.${SearchCriteriaSortFieldEnum.engagement_total}`, SearchCriteriaSortFieldEnum.engagement_total),
                new DropdownOptionModel(`Reports.topMentions.sortField.${SearchCriteriaSortFieldEnum.audience_reach}`, SearchCriteriaSortFieldEnum.audience_reach),
                new DropdownOptionModel(`Reports.topMentions.sortField.${SearchCriteriaSortFieldEnum.share}`, SearchCriteriaSortFieldEnum.share),
                new DropdownOptionModel(`Reports.topMentions.sortField.${SearchCriteriaSortFieldEnum.function}`, SearchCriteriaSortFieldEnum.function),
                new DropdownOptionModel(`Reports.topMentions.sortField.${SearchCriteriaSortFieldEnum.like}`, SearchCriteriaSortFieldEnum.like),
                new DropdownOptionModel(`Reports.topMentions.sortField.${SearchCriteriaSortFieldEnum.view}`, SearchCriteriaSortFieldEnum.view),
                new DropdownOptionModel(`Reports.topMentions.sortField.${SearchCriteriaSortFieldEnum.custom}`, SearchCriteriaSortFieldEnum.custom)
            ]
        ),
        new TopCuratedMentionsFieldModel(
            'topCuratedMentions',
            TopCuratedMentionsFieldComponent,
            'topMentions_topCuratedMentions'
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.dataSource.singleSeries.label',
            'dataSource_heading',
            (displayElement: ChartDisplayElementModel) => displayElement.topMentionsSortField !== SearchCriteriaSortFieldEnum.custom
        ),
        new SeriesPickerFieldModel(
            SeriesPickerFieldComponent,
            'series',
            '',
            '',
            false,
            1,
            [
                ...mentionSeriesTypes,
                ...socialSeriesTypes
            ],
            undefined,
            undefined,
            false,
            true,
            false,
            'topPosts_dataSource',
            (displayElement: ChartDisplayElementModel) => displayElement.topMentionsSortField !== SearchCriteriaSortFieldEnum.custom
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.chartSetupDialog.networkSelection',
            'network_heading',
            (displayElement: ChartDisplayElementModel) => displayElement.topMentionsSortField !== SearchCriteriaSortFieldEnum.custom
        ),
        new CheckboxesFieldModel(
            ChartNetworkCheckboxFieldComponent,
            'networkSelection',
            '',
            '',
            [],
            false,
            'network_heading',
            (displayElement: ChartDisplayElementModel) => displayElement.topMentionsSortField !== SearchCriteriaSortFieldEnum.custom
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.chartSetupDialog.displaySettings',
            ''
        ),
        new ChartDisplaySettingsFieldModel(
            'chartHeaderSettings',
            ChartDisplaySettingsFieldComponent,
            ''
        ),
    ],
    TopPostChartBlockComponent
);

export const coverageMetricBlockType: BlockTypeModel = new BlockTypeModel(
    ReportBlockTypeEnum.COVERAGE_METRIC,
    `Reports.chart.title.${ReportBlockTypeEnum.COVERAGE_METRIC}`,
    'fa-regular fa-duotone fa-chart-line',
    'Chart goes here!',
    CoverageMetricChartDisplayElement,
    [
        new TextFieldModel(
            TextFieldComponent,
            'title',
            'Reports.formField.chartTitle',
            null,
            false,
            64,
            'Reports.formField.chartTitle.placeholder'
        ),
        new ChartAnalysisMetricDropdownFieldModel(
            MetricPickerComponent,
            'metric',
            'Reports.formField.analysis.metric',
            '',
            [
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.volumeOfMentions}`, ChartMetricsEnum.volumeOfMentions),
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.audienceReach}`, ChartMetricsEnum.IMPRESSIONS),
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.ave}`, ChartMetricsEnum.ave),
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.AVERAGE_DOMAIN_AUTHORITY}`, ChartMetricsEnum.AVERAGE_DOMAIN_AUTHORITY),
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.positiveSentimentPercentage}`, ChartMetricsEnum.positiveSentimentPercentage),
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.neutralSentimentPercentage}`, ChartMetricsEnum.neutralSentimentPercentage),
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.negativeSentimentPercentage}`, ChartMetricsEnum.negativeSentimentPercentage),
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.POSITIVE}`, ChartMetricsEnum.POSITIVE),
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.NEUTRAL}`, ChartMetricsEnum.NEUTRAL),
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.NEGATIVE}`, ChartMetricsEnum.NEGATIVE),
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.ENGAGEMENTS}`, ChartMetricsEnum.ENGAGEMENTS),
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.ENGAGEMENTS_PER_POST}`, ChartMetricsEnum.ENGAGEMENTS_PER_POST),
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.ENGAGEMENT_RATE}`, ChartMetricsEnum.ENGAGEMENT_RATE),
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.APPLAUSE}`, ChartMetricsEnum.APPLAUSE),
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.CONVERSATION}`, ChartMetricsEnum.CONVERSATION),
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.AMPLIFICATION}`, ChartMetricsEnum.AMPLIFICATION),
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.VIEWS}`, ChartMetricsEnum.VIEWS),
                new DropdownOptionModel(`Reports.formField.analysis.${ChartMetricsEnum.custom}`, ChartMetricsEnum.custom)
            ],
            'Reports.analysis.select',
            undefined,
            'analysis_heading',
            {
                usePreviousValue: true
            }
        ),
        new DropdownFieldModel(
            DropdownFieldComponent,
            'titleIcon',
            'Reports.formField.analysis.icon',
            '',
            [
                new DropdownOptionModel(
                    `Reports.formField.analysis.${ChartMetricsEnum.volumeOfMentions}.parenthesis`,
                    ChartMetricsEnum.volumeOfMentions,
                    null,
                    chartMetricsToCoverageMetricIconsMap.get(ChartMetricsEnum.volumeOfMentions)
                ),
                new DropdownOptionModel(
                    `Reports.formField.analysis.${ChartMetricsEnum.IMPRESSIONS}.parenthesis`,
                    ChartMetricsEnum.IMPRESSIONS,
                    null,
                    chartMetricsToCoverageMetricIconsMap.get(ChartMetricsEnum.IMPRESSIONS)
                ),
                new DropdownOptionModel(
                    `Reports.formField.analysis.${ChartMetricsEnum.ave}.parenthesis`,
                    ChartMetricsEnum.ave,
                    null,
                    chartMetricsToCoverageMetricIconsMap.get(ChartMetricsEnum.ave)
                ),
                new DropdownOptionModel(
                    `Reports.formField.analysis.${ChartMetricsEnum.AVERAGE_DOMAIN_AUTHORITY}.parenthesis`,
                    ChartMetricsEnum.AVERAGE_DOMAIN_AUTHORITY,
                    null,
                    chartMetricsToCoverageMetricIconsMap.get(ChartMetricsEnum.AVERAGE_DOMAIN_AUTHORITY)
                ),
                new DropdownOptionModel(
                    `Reports.formField.analysis.${ChartMetricsEnum.POSITIVE}.parenthesis`,
                    ChartMetricsEnum.POSITIVE,
                    null,
                    chartMetricsToCoverageMetricIconsMap.get(ChartMetricsEnum.POSITIVE)
                ),
                new DropdownOptionModel(
                    `Reports.formField.analysis.${ChartMetricsEnum.NEUTRAL}.parenthesis`,
                    ChartMetricsEnum.NEUTRAL,
                    null,
                    chartMetricsToCoverageMetricIconsMap.get(ChartMetricsEnum.NEUTRAL)
                ),
                new DropdownOptionModel(
                    `Reports.formField.analysis.${ChartMetricsEnum.NEGATIVE}.parenthesis`,
                    ChartMetricsEnum.NEGATIVE,
                    null,
                    chartMetricsToCoverageMetricIconsMap.get(ChartMetricsEnum.NEGATIVE)
                ),
                new DropdownOptionModel(
                    `Reports.formField.analysis.${ChartMetricsEnum.ENGAGEMENTS}.parenthesis`,
                    ChartMetricsEnum.ENGAGEMENTS,
                    null,
                    chartMetricsToCoverageMetricIconsMap.get(ChartMetricsEnum.ENGAGEMENTS)
                ),
                new DropdownOptionModel(
                    `Reports.formField.analysis.${ChartMetricsEnum.ENGAGEMENTS_PER_POST}.parenthesis`,
                    ChartMetricsEnum.ENGAGEMENTS_PER_POST,
                    null,
                    chartMetricsToCoverageMetricIconsMap.get(ChartMetricsEnum.ENGAGEMENTS_PER_POST)
                ),
                new DropdownOptionModel(
                    `Reports.formField.analysis.${ChartMetricsEnum.ENGAGEMENT_RATE}.parenthesis`,
                    ChartMetricsEnum.ENGAGEMENT_RATE,
                    null,
                    chartMetricsToCoverageMetricIconsMap.get(ChartMetricsEnum.ENGAGEMENT_RATE)
                ),
                new DropdownOptionModel(
                    `Reports.formField.analysis.${ChartMetricsEnum.APPLAUSE}.parenthesis`,
                    ChartMetricsEnum.APPLAUSE,
                    null,
                    chartMetricsToCoverageMetricIconsMap.get(ChartMetricsEnum.APPLAUSE)
                ),
                new DropdownOptionModel(
                    `Reports.formField.analysis.${ChartMetricsEnum.CONVERSATION}.parenthesis`,
                    ChartMetricsEnum.CONVERSATION,
                    null,
                    chartMetricsToCoverageMetricIconsMap.get(ChartMetricsEnum.CONVERSATION)
                ),
                new DropdownOptionModel(
                    `Reports.formField.analysis.${ChartMetricsEnum.AMPLIFICATION}.parenthesis`,
                    ChartMetricsEnum.AMPLIFICATION,
                    null,
                    chartMetricsToCoverageMetricIconsMap.get(ChartMetricsEnum.AMPLIFICATION)
                ),
                new DropdownOptionModel(
                    `Reports.formField.analysis.${ChartMetricsEnum.VIEWS}.parenthesis`,
                    ChartMetricsEnum.VIEWS,
                    null,
                    chartMetricsToCoverageMetricIconsMap.get(ChartMetricsEnum.VIEWS)
                ),
                ...Object.values(ChartIconEnum).map(icon =>
                    new DropdownOptionModel(
                        `Reports.formField.analysis.${icon}.parenthesis`,
                        icon,
                        null,
                        chartIconToCoverageIconMap.get(icon)
                    )
                )
            ],
            '',
            '',
            null,
            'agpr-dropdown-panel--leftAligned',
            (component: DropdownFieldComponent, changes: any) => {
                const metricChanges: SimpleChange = changes?.['metric'];
                if (metricChanges) {
                    const previousValue = metricChanges.previousValue;
                    let metric = (component.block?.displayElement as ChartDisplayElementModel)?.metric;
                    const sentimentsMergeToIconsMap = new Map<ChartMetricsEnum, ChartMetricsEnum>([
                        [ChartMetricsEnum.positiveSentimentPercentage, ChartMetricsEnum.POSITIVE],
                        [ChartMetricsEnum.neutralSentimentPercentage, ChartMetricsEnum.NEUTRAL],
                        [ChartMetricsEnum.negativeSentimentPercentage, ChartMetricsEnum.NEGATIVE]
                    ]);
                    metric = sentimentsMergeToIconsMap.get(metric) || metric;
                    if (component.block?.displayElement
                        && metric !== ChartMetricsEnum.custom
                        && metric !== previousValue
                    ) {
                        (component.block?.displayElement as CoverageMetricChartDisplayElement).titleIcon = metric;
                        component.writeValue(metric);
                    }
                }
            }
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formField.dataSource.singleSeries.label',
            'dataSource_heading',
            (displayelement: ChartDisplayElementModel) => displayelement.metric !== ChartMetricsEnum.custom
        ),
        new SeriesPickerFieldModel(
            SeriesPickerFieldComponent,
            'series',
            '',
            '',
            false,
            1,
            [
                ...mentionSeriesTypes,
                ...socialSeriesTypes
            ],
            socialSeriesFilterTypes,
            undefined,
            false,
            false,
            false,
            'dataSource_heading',
            (displayelement: ChartDisplayElementModel) => displayelement.metric !== ChartMetricsEnum.custom
        ),
        new DateRangeFieldModel(
            DateRangeFieldComponent,
            'series',
            'Reports.formField.dateRange.label',
            '',
            true,
            (displayelement: ChartDisplayElementModel) => displayelement.metric !== ChartMetricsEnum.custom
        ),
        new NumberFieldModel(
            NumberFieldComponent,
            'customCurrentValue',
            'Reports.formField.analysis.metric.currentValue',
            null,
            'Reports.formField.analysis.metric.currentValue.placeholder',
            null,
            0,
            null,
            null,
            (block: BlockModel) => {
                return (block.displayElement as ChartDisplayElementModel).metric === ChartMetricsEnum.custom;
            }
        ),
        new CoverageMetricChartDisplaySettingsField(
            'chartHeaderSettings',
            CoverageMetricChartDisplaySettingsFieldComponent,
            'Reports.chartSetupDialog.displaySettings',
            null
        ),
        new StaticTextHeadingFieldModel(
            StaticTextHeadingFieldComponent,
            'Reports.formfield.metadata.colorSettings'
        ),
        new ChartColorPickerFieldModel(
            ChartColorPickerFieldComponent,
            {
                property: 'styles.colorMap.accentColor',
                key: 'accentColor',
                label: 'Reports.chartSetupDialog.accentColor',
                description: '',
                dialogHeading: '',
                doBorder: true,
                showRecentColors: true
            },
            null
        )
    ],
    CoverageMetricChartBlockComponent
);

// Order determines the order of the options in the chart setup dialog
export const dashboardsBlockTypes: BlockTypeModel[] = [
    recentTopicActivityBlockType,
    recentTargetingActivityBlockType,
    recentDistributionActivityBlockType,
    recentReportsDistributionsBlockType,
    recentSurgeActivityBlockType
];

export const dashboardBlockTypesMap: Map<ReportBlockTypeEnum, BlockTypeModel> = new Map<ReportBlockTypeEnum, BlockTypeModel>([
    [ReportBlockTypeEnum.RECENT_TOPICS, recentTopicActivityBlockType],
    [ReportBlockTypeEnum.RECENT_TARGETING_ACTIVITY, recentTargetingActivityBlockType],
    [ReportBlockTypeEnum.RECENT_DISTRIBUTION_ACTIVITY, recentDistributionActivityBlockType],
    [ReportBlockTypeEnum.RECENT_REPORTS_DISTRIBUTIONS, recentReportsDistributionsBlockType],
    [ReportBlockTypeEnum.RECENT_SURGE_ALERTS, recentSurgeActivityBlockType],
]);

export const reportBlockTypesMap: Map<ReportBlockTypeEnum, BlockTypeModel> = new Map<ReportBlockTypeEnum, BlockTypeModel>([
    [ReportBlockTypeEnum.COVERAGE_SUMMARY, coverageSummaryBlockType],
    [ReportBlockTypeEnum.COVERAGE_OVER_TIME, coverageOverTimeBlockType],
    [ReportBlockTypeEnum.COVERAGE_OVER_TIME_COMPARISON, coverageOverTimeComparisonBlockType],
    [ReportBlockTypeEnum.COVERAGE_COMPARISON, coverageComparisonBlockType],
    [ReportBlockTypeEnum.SENTIMENT_BREAKDOWN, sentimentBreakdownBlockType],
    [ReportBlockTypeEnum.SENTIMENT_BREAKDOWN_COMPARISON, sentimentBreakdownComparisonBlockType],
    [ReportBlockTypeEnum.MEDIA_TYPE_BREAKDOWN, mediaTypeBreakdownBlockType],
    [ReportBlockTypeEnum.MEDIA_TYPE_BREAKDOWN_COMPARISON, mediaTypeBreakdownComparisonBlockType],
    [ReportBlockTypeEnum.GEOGRAPHY_BREAKDOWN_BY_VOLUME, geographyBreakdownBlockType],
    [ReportBlockTypeEnum.SHARE_OF_VOICE, shareOfVoiceBlockType],
    [ReportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME, authorsBreakdownBlockType],
    [ReportBlockTypeEnum.TOP_HASHTAGS, topHashtagsBlockType],
    [ReportBlockTypeEnum.TOP_10_OUTLETS, outletsBreakdownBlockType],
    [ReportBlockTypeEnum.COVERAGE_IMPACT_TREND, coverageImpactTrendBlockType],
    [ReportBlockTypeEnum.REFERRAL_TREND, referralTrendBlockType],
    [ReportBlockTypeEnum.PROMINENCE_OVER_TIME, prominenceOverTimeBlockType],
    [ReportBlockTypeEnum.PROMINENCE_BY_REACH, prominenceByReachBlockType],
    [ReportBlockTypeEnum.TOP_SOCIAL_REFERRERS, topSocialReferrersBlockType],
    [ReportBlockTypeEnum.TOP_REFERRAL_SOURCES, topReferralSourcesBlockType],
    [ReportBlockTypeEnum.SOCIAL_COVERAGE_BY_NETWORK, socialCoverageByNetwork],
    [ReportBlockTypeEnum.TOP_TERMS, topTermsBlockType],
    [ReportBlockTypeEnum.SENTIMENT_TREND, sentimentTrendBlockType],
    [ReportBlockTypeEnum.TOP_MENTIONS, topMentionsBlockType],
    [ReportBlockTypeEnum.TOP_POSTS, topPostsBlockType],
    [ReportBlockTypeEnum.COVERAGE_METRIC, coverageMetricBlockType]
]);

export const reportsBlockTypes: BlockTypeModel[] = [
    coverageSummaryBlockType,
    coverageOverTimeBlockType,
    coverageOverTimeComparisonBlockType,
    coverageComparisonBlockType,
    sentimentBreakdownBlockType,
    sentimentBreakdownComparisonBlockType,
    sentimentTrendBlockType,
    mediaTypeBreakdownBlockType,
    mediaTypeBreakdownComparisonBlockType,
    geographyBreakdownBlockType,
    shareOfVoiceBlockType,
    outletsBreakdownBlockType,
    authorsBreakdownBlockType,
    topHashtagsBlockType,
    coverageImpactTrendBlockType,
    referralTrendBlockType,
    prominenceOverTimeBlockType,
    prominenceByReachBlockType,
    topSocialReferrersBlockType,
    topReferralSourcesBlockType,
    socialCoverageByNetwork,
    topTermsBlockType,
    topMentionsBlockType,
    topPostsBlockType,
    coverageMetricBlockType
];

export const dynamicBlockComponentMap: Map<ChartSpecificTypesEnum, Type<BlockComponent>> = new Map<ChartSpecificTypesEnum, Type<BlockComponent>>([
    [ChartSpecificTypesEnum.CARD_LIST, TopTermChartBlockComponent],
    [ChartSpecificTypesEnum.WORD_CLOUD, ChartBlockComponent]
]);

export const dynamicDashboardBlockComponentMap: Map<ChartSpecificTypesEnum, Type<BlockComponent>> = new Map<ChartSpecificTypesEnum, Type<BlockComponent>>([
    [ChartSpecificTypesEnum.CARD_LIST, DashboardTopTermChartBlockComponent],
    [ChartSpecificTypesEnum.WORD_CLOUD, DashboardChartBlockComponent]
]);
